export const pt = {
  // Navigation
  nav: {
    dashboard: 'Dashboard',
    vehicles: 'Veículos',
    leads: 'Leads',
    allLeads: 'Todos os Leads',
    conversations: 'Conversas',
    proposals: 'Propostas',
    marketplace: 'Marketplace',
    newLead: 'Novo lead',
    newVehicle: 'Novo veículo',
    financial: 'Financeiro',
    management: 'Gestão',
    sellers: 'Vendedores',
    maintenance: 'Manutenção',
    users: 'Usuários',
    settings: 'Configurações',
    settingsGeneral: 'Geral',
    settingsTheme: 'Tema',
    settingsDealership: 'Concessionária',
    settingsPaymentForms: 'Formas de Pagamento',
    settingsRoles: 'Papéis e Permissões',
    settingsSub: {
      general: 'Geral',
      theme: 'Tema',
      dealership: 'Concessionária',
      paymentForms: 'Formas de Pagamento',
      operation: 'Operação',
      leads: 'Leads',
      vehicleEvaluation: 'Avaliação de Veículos',
      operationPipeline: 'Esteira de vendas',
      operationPreparation: 'Esteira de preparação',
      leadsSources: 'Catálogo de mídias',
      leadsMedia: 'Mídias ativas',
      roleAccess: 'Acesso por perfil',
      billing: 'Assinatura e cobrança',
    },
    salesSection: 'Vendas',
    leadsSettingsSub: {
      kanban: 'Kanban',
      webhooks: 'Webhooks',
    },
    bottomNav: {
      sales: 'Negócios fechados',
      pipeline: 'Esteira de vendas',
    },
    products: 'Produtos/Serviços',
    more: 'Mais',
    profile: 'Meu Perfil',
    logout: 'Sair',
    lightMode: 'Modo claro',
    darkMode: 'Modo escuro',
    financialSub: {
      overview: 'Visão Geral',
      charges: 'Encargos',
      benefits: 'Benefícios',
      invoices: 'Faturas',
      payments: 'Pagamentos',
      commissions: 'Comissões',
      commissionRules: 'Regras de Comissão',
      closures: 'Fechamentos',
      fiscalDocuments: 'Docs. Fiscais',
    },
    sales: 'Vendas',
    salesSub: {
      closedDeals: 'Negócios fechados',
      acceptedProposals: 'Propostas aceitas',
    },
    operation: 'Operação',
    operationSub: {
      postSale: 'Pós-venda',
      preparation: 'Preparação',
      deliveries: 'Entregas',
      postReceipt: 'Pós-recebimento',
      taskSettings: 'Configuração de tarefas',
    },
    operationPipelineSettings: 'Esteira e pré-venda',
    postSales: 'Pós-vendas',
    postSalesSub: {
      dashboard: 'Dashboard',
      salesPipeline: 'Esteira de vendas',
      preparationPipeline: 'Esteira de preparação',
      deliveries: 'Entregas',
      configureSalesPipeline: 'Configurações',
      postReceipt: 'Pós-recebimento',
    },
    leadsSub: {
      all: 'Todos os Leads',
      report: 'Relatório',
      conversations: 'Conversas',
      distribution: 'Distribuição',
      settings: 'Configurações',
    },
    marketplaceSub: {
      integrations: 'Integrações',
      publications: 'Publicações',
      history: 'Histórico',
    },
  },

  roleAccess: {
    title: 'Acesso por perfil',
    subtitle: 'Defina quais menus e funções cada perfil pode acessar na sua concessionária.',
    loadError: 'Erro ao carregar permissões.',
    saveError: 'Erro ao salvar permissões.',
    saveSuccess: 'Permissões atualizadas com sucesso.',
    save: 'Salvar alterações',
    saving: 'Salvando...',
    ownerOnly: 'Somente o proprietário pode gerenciar o acesso por perfil.',
    ownerFullAccess: 'O proprietário tem acesso total e não pode ser restringido.',
    sectionRoot: 'Menu principal',
    roles: {
      owner: 'Proprietário',
      manager: 'Gerente',
      salesperson: 'Vendedor',
      financial: 'Financeiro',
      mechanic: 'Mecânico',
      viewer: 'Visualizador',
    },
  },

  myProfile: {
    title: 'Meu perfil',
    subtitle: 'Atualize seus dados, foto e preferências',
    tabs: {
      data: 'Dados',
      photo: 'Foto',
      security: 'Segurança',
    },
    name: 'Nome completo',
    namePlaceholder: 'Seu nome completo',
    email: 'E-mail',
    emailPlaceholder: 'seu@email.com',
    phone: 'Telefone',
    phoneCountryCode: 'Código do país',
    phoneArea: 'DDD',
    phoneNumber: 'Número',
    phonePlaceholder: '999999999',
    phoneHelp: 'Use o número que sua equipe usa no dia a dia.',
    phoneRequired: 'Telefone é obrigatório',
    cancel: 'Cancelar',
    save: 'Salvar alterações',
    saving: 'Salvando...',
    success: 'Perfil atualizado com sucesso!',
    nameRequired: 'Nome é obrigatório',
    heroRole: 'Cargo',
    heroStatus: 'Status',
    heroLastLogin: 'Último acesso',
    heroCreatedAt: 'Conta criada',
    statusActive: 'Ativo',
    statusInactive: 'Inativo',
    contextBackoffice: 'Backoffice',
    contextDealership: 'Concessionária',
    roles: {
      owner: 'Proprietário',
      manager: 'Gerente',
      salesperson: 'Vendedor',
      financial: 'Financeiro',
      mechanic: 'Mecânico',
      viewer: 'Visualizador',
    },
    photoTitle: 'Foto do perfil',
    photoDescription: 'Escolha uma imagem quadrada para ficar bonita no topo do sistema.',
    photoUpload: 'Escolher foto',
    photoRemove: 'Remover foto',
    photoHint: 'A imagem fica salva neste navegador e aparece no cabeçalho do app.',
    securityTitle: 'Segurança e acesso',
    securityDescription: 'Resumo da sua conta e permissões atuais.',
    securityNeverLogin: 'Ainda sem histórico de acesso',
    securityActive: 'Conta ativa',
    securityInactive: 'Conta inativa',
  },

  userRegistration: {
    titleCreate: 'Novo Usuário',
    titleEdit: 'Editar Usuário',
    subtitleCreate: 'Cadastre um novo usuário na sua concessionária',
    subtitleEdit: 'Edite as informações do usuário',
    back: 'Voltar',
    cardTitle: 'Informações do Usuário',
    nameLabel: 'Nome Completo',
    namePlaceholder: 'Digite o nome completo',
    emailLabel: 'Email',
    emailPlaceholder: 'usuario@empresa.com',
    countryCodeLabel: 'Código do País',
    countryCodePlaceholder: '+55',
    areaLabel: 'DDD',
    areaPlaceholder: '11',
    phoneLabel: 'Telefone',
    phonePlaceholder: '99999-9999',
    userStatusLabel: 'Status do Usuário',
    active: 'Ativo',
    inactive: 'Inativo',
    roleLabel: 'Perfil *',
    loadingRoles: 'Carregando perfis...',
    selectedRolePrefix: 'Perfil Selecionado:',
    passwordLabel: 'Senha',
    passwordPlaceholder: 'Mínimo 6 caracteres',
    confirmPasswordLabel: 'Confirmar Senha',
    confirmPasswordPlaceholder: 'Confirme a senha',
    roleInfoPrefix: 'Perfil Selecionado:',
    cancel: 'Cancelar',
    submitCreate: 'Cadastrar Usuário',
    submitEdit: 'Salvar Alterações',
    successCreate: 'Usuário cadastrado com sucesso!',
    createError: 'Erro ao cadastrar usuário. Tente novamente.',
    validation: {
      nameRequired: 'Nome é obrigatório',
      emailRequired: 'Email é obrigatório',
      emailInvalid: 'Email inválido',
      passwordRequired: 'Senha é obrigatória',
      passwordMin: 'Senha deve ter pelo menos 6 caracteres',
      confirmPasswordRequired: 'Confirmação de senha é obrigatória',
      passwordMismatch: 'Senhas não coincidem',
      roleRequired: 'Perfil é obrigatório',
      areaRequired: 'DDD é obrigatório',
      phoneRequired: 'Telefone é obrigatório',
    },
  },

  userProfile: {
    title: 'Perfil do Usuário',
    subtitle: 'Visualize e edite as informações do usuário',
    backToList: 'Voltar para Lista',
    back: 'Voltar',
    edit: 'Editar',
    notFoundTitle: 'Usuário não encontrado',
    notFoundDescription: 'O usuário solicitado não foi encontrado.',
    basicInfoTitle: 'Informações Básicas',
    detailsTitle: 'Informações Detalhadas',
    editInfoTitle: 'Editar Informações',
    namePlaceholder: 'João Silva',
    emailPlaceholder: 'joao@exemplo.com',
    newPasswordLabel: 'Nova Senha (opcional)',
    newPasswordPlaceholder: 'Deixe em branco para manter a atual',
    confirmNewPasswordLabel: 'Confirmar Nova Senha',
    confirmNewPasswordPlaceholder: 'Confirme a nova senha',
    phonesLabel: 'Telefones',
    noPhones: 'Nenhum telefone cadastrado',
    noPhonesAdded: 'Nenhum telefone adicionado',
    addPhone: 'Adicionar Telefone',
    addPhoneToStart: 'Clique em "Adicionar Telefone" para começar',
    phoneItemLabel: 'Telefone {{number}}',
    primaryBadge: 'Principal',
    makePrimary: 'Tornar principal',
    countryCodeLabel: 'Código do País',
    countryCodePlaceholder: '+55',
    areaLabel: 'DDD',
    areaPlaceholder: '11',
    phoneLabel: 'Telefone',
    phonePlaceholder: '99999-9999',
    roleLabel: 'Perfil',
    selectProfile: 'Selecione um perfil',
    userStatusLabel: 'Status do Usuário',
    createdAtLabel: 'Criado em',
    lastLoginLabel: 'Último Login',
    profileDescriptionTitle: 'Descrição do Perfil',
    successUpdate: 'Perfil atualizado com sucesso!',
    validation: {
      phonesRequired: 'Pelo menos um telefone é obrigatório',
    },
  },

  // Dashboard

  vehicleRegistration: {
    basic: {
      title: 'Informações Básicas do Veículo',
      branchLabel: 'Filial',
      branchLoadingPlaceholder: 'Carregando filiais...',
      branchPlaceholder: 'Selecione uma filial (opcional)',
      noBranchesWarning: 'Nenhuma filial ativa disponível.',
      noBranchSelectedInfo: 'Selecione uma filial para continuar.',
      nameLabel: 'Nome do Veículo',
      nameHint: 'Será preenchido automaticamente ao selecionar marca, modelo e ano',
      namePlaceholder: 'Será preenchido automaticamente',
      generateName: 'Gerar Nome',
      generateNameTitle: 'Gerar nome automaticamente',
      brandLabel: 'Marca',
      brandPlaceholder: 'Buscar marca...',
      brandEmpty: 'Nenhuma marca encontrada',
      modelLabel: 'Modelo',
      modelPlaceholder: 'Buscar modelo...',
      modelSelectBrandFirst: 'Selecione uma marca primeiro',
      modelEmpty: 'Nenhum modelo encontrado',
      conditionLabel: 'Condição',
      conditionPlaceholder: 'Selecione a condição',
      modelYearLabel: 'Ano Modelo',
      modelYearPlaceholder: 'Selecione o ano modelo',
      manufactureYearLabel: 'Ano de Fabricação',
      manufactureYearPlaceholder: 'Selecione o ano de fabricação',
      manufactureYearHint: 'Ano de fabricação pode ser igual ao ano modelo ou 1 ano anterior',
      colorLabel: 'Cor',
      primaryColorLabel: 'Cor Primária',
      secondaryColorLabel: 'Cor Secundária',
      colorPlaceholder: 'Selecione',
      colorOptionalPlaceholder: 'Selecione (opcional)',
      mileageLabel: 'Quilometragem',
      mileagePlaceholder: '50.000',
      mileageZeroPlaceholder: '0 km',
      mileageHint: 'Quilometragem definida automaticamente para veículos 0 km',
      mileageRequiredHint: 'Quilometragem *',
      mileageAutoHint: 'Quilometragem definida automaticamente para veículos 0 km',
    },
    pricing: {
      title: 'Valores do Veículo',
      description: 'Informe os valores manualmente; não há mais consulta à FIPE neste fluxo.',
      manualInfo: 'Os valores de venda, mínimo e compra são preenchidos manualmente.',
      salePriceTitle: 'Preço de Venda',
      requiredBadge: 'Obrigatório',
      minimumPriceTitle: 'Preço Mínimo de Venda',
      confidentialBadge: 'Confidencial',
      confidentialInfoTitle: 'Informação Confidencial',
      confidentialInfoMessage: 'O valor mínimo é privado e não será exibido publicamente. Será utilizado apenas em negociações e relatórios internos para controle de margem.',
      minPriceWarning: 'O preço mínimo não pode ser maior que o preço de venda.',
      purchasePriceTitle: 'Valor Pago no Veículo',
      purchasePriceInfoMessage: 'Este valor é privado e não será exibido publicamente. Será utilizado apenas em relatórios internos para análise de margem.',
      diffTitle: 'Diferença',
      diffSubtitle: 'Venda − Valor pago',
      minDiffTitle: 'Dif. Mínima',
      minDiffSubtitle: 'Mínimo − Valor pago',
      hidePricingLabel: 'Ocultar valores confidenciais para vendedores',
      hidePricingDescription: 'Quando marcado, o valor pago e o preço mínimo ficarão ocultos para os vendedores nas propostas e negociações. Apenas administradores e gestores poderão visualizar estes valores.',
      activeBadge: 'Ativado',
      statusTitle: 'Status do Veículo',
      statusDescription: 'Selecione o status atual do veículo',
      statusLabel: 'Status',
      statusPlaceholder: 'Selecione o status',
    },
    specifications: {
      carTitle: 'Especificações Técnicas',
      motorcycleTitle: 'Especificações Técnicas da Motocicleta',
      truckTitle: 'Especificações Técnicas do Caminhão',
      busTitle: 'Especificações Técnicas do Ônibus',
      fuelLabel: 'Combustível',
      transmissionLabel: 'Transmissão',
      automaticHint: 'Automático — padrão para veículos elétricos/híbridos',
      formHint: 'Informado no formulário',
      bodyTypeLabel: 'Tipo de Carroceria',
      bodyTypePlaceholder: 'Selecione o tipo de carroceria',
      bodyTypeShortPlaceholder: 'Selecione o tipo',
      doorsLabel: 'Número de Portas',
      doorsPlaceholder: '4',
      steeringLabel: 'Direção',
      steeringPlaceholder: 'Selecione a direção',
      motorcycleEngineLabel: 'Tipo de Motor',
      motorcycleCoolingLabel: 'Tipo de Refrigeração',
      motorcycleStarterLabel: 'Tipo de Partida',
      motorcycleFeedingLabel: 'Tipo de Alimentação',
      motorcycleFrontBrakeLabel: 'Freio Dianteiro',
      motorcycleRearBrakeLabel: 'Freio Traseiro',
      motorcycleGearsLabel: 'Número de Marchas',
      motorcycleGearsPlaceholder: '6',
      motorcycleCylinderLabel: 'Cilindrada (cc)',
      motorcycleCylinderPlaceholder: '150',
      motorcycleStyleLabel: 'Estilo',
      motorcycleCategoryLabel: 'Categoria',
      truckBodyTypeLabel: 'Tipo de Carroceria',
      truckBodyTypePlaceholder: 'Selecione a carroceria',
      truckCabTypeLabel: 'Tipo de Cabine',
      truckCabTypePlaceholder: 'Selecione a cabine',
      truckTractionLabel: 'Tração',
      truckTractionPlaceholder: 'Selecione a tração',
      truckAxlesLabel: 'Número de Eixos',
      truckAxlesPlaceholder: '3',
      truckGrossVehicleWeightLabel: 'PBT — Peso Bruto Total (kg)',
      truckGrossVehicleWeightPlaceholder: '23000',
      truckPayloadLabel: 'Capacidade de Carga (kg)',
      truckPayloadPlaceholder: '15000',
      truckTiresLabel: 'Quantidade de Pneus',
      truckTiresPlaceholder: '6',
      busBodyBrandLabel: 'Marca da Carroceria',
      busBodyBrandPlaceholder: 'Selecione',
      busBodyModelLabel: 'Modelo da Carroceria',
      busBodyModelPlaceholder: 'Ex: Paradiso, Torino, Apache...',
      busOperationTypeLabel: 'Tipo de Operação',
      busOperationTypePlaceholder: 'Selecione',
      busFleetNumberLabel: 'Número de Frota',
      busFleetNumberPlaceholder: 'Ex: 1042',
      busSeatedCapacityLabel: 'Capacidade Sentada',
      busSeatedCapacityPlaceholder: '44',
      busStandingCapacityLabel: 'Capacidade em Pé',
      busStandingCapacityPlaceholder: '20',
      busWheelchairCapacityLabel: 'Vagas para Cadeirante',
      busWheelchairCapacityPlaceholder: '2',
      featuresTitle: 'Itens e Opcionais do Veículo',
      busFeaturesTitle: 'Equipamentos do Ônibus',
      featuresDescription: 'Selecione os itens e características que o veículo possui (opcional)',
      featuresTipTitle: 'Dica:',
      featuresTipMessage: 'Selecione apenas as características que o veículo realmente possui. Isso ajuda os clientes a encontrar exatamente o que procuram.',
      comfortGroupTitle: 'Conforto',
      safetyGroupTitle: 'Segurança',
      technologyGroupTitle: 'Tecnologia',
      convenienceGroupTitle: 'Conveniência',
      performanceGroupTitle: 'Performance',
      lightingGroupTitle: 'Iluminação',
      adasGroupTitle: 'Sistemas Avançados (ADAS)',
      busEquipmentGroupTitle: 'Equipamentos',
      armorTitle: 'Blindagem e Categoria Especial',
      armorDescription: 'Configure se o veículo possui blindagem ou categoria especial',
      armorLabel: 'Nível de Blindagem',
      armorPlaceholder: 'Selecione o nível de blindagem',
      specialCategoryLabel: 'Categoria Especial',
      specialCategoryPlaceholder: 'Selecione a categoria especial',
      armorOptionalTitle: 'Opcional:',
      armorOptionalMessage: 'Configure apenas se o veículo possuir blindagem ou categoria especial (ex: táxi, ambulância, etc).',
      otherCharacteristicsTitle: 'Outras Características',
      otherCharacteristicsDescription: 'Características adicionais e diferenciais do veículo',
      otherCharacteristicsOptionalMessage: 'Selecione características adicionais que destacam o veículo (ex: único dono, revisões em dia, etc).',
      legalTitle: 'Situação Legal',
      legalDescription: 'Indique se existe algum ônus ou restrição financeira sobre o veículo',
      alienatedLabel: 'Veículo Alienado / Com Financiamento',
      alienatedActiveDescription: 'Este veículo possui financiamento ativo. Informe o valor da dívida nas propostas de troca.',
      alienatedInactiveDescription: 'Indique se existe financiamento, consórcio ou alienação fiduciária sobre este veículo.',
      selectPlaceholder: 'Selecione',
      fuelSelectPlaceholder: 'Selecione o combustível',
      transmissionSelectPlaceholder: 'Selecione a transmissão',
    },
    documentation: {
      title: 'Documentação do Veículo',
      plateLabel: 'Placa',
      chassisLabel: 'Chassi',
      chassisPlaceholder: '9BWZZZ377VT004251',
      renavamLabel: 'RENAVAM',
      renavamPlaceholder: '00000000000',
      documentsLabel: 'Documentos do Veículo',
      addDocumentsLabel: 'Adicionar Novos Documentos',
      documentsHint: 'Envie documentos como CRLV, nota fiscal, etc. Selecione a categoria de cada documento. Formatos aceitos: PDF, JPG, PNG',
      inspectedLabel: 'Veículo Vistoriado',
      inspectedDescription: 'Marque se o veículo passou por vistoria técnica',
      inspectedBadge: 'Vistoriado',
      inspectionDateLabel: 'Data da Vistoria',
      inspectionDatePlaceholder: 'Selecione a data da vistoria',
      inspectionTitle: 'Vistoria e Inspeção',
      auctionTitle: 'Informações de Leilão',
      auctionLabel: 'Veículo de Leilão',
      auctionDescription: 'Marque se este veículo veio de leilão',
      auctionBadge: 'Leilão',
      auctionCategoryLabel: 'Categoria do Leilão',
      auctionCategoryPlaceholder: 'Selecione a categoria',
      auctionSubtypeLabel: 'Subtipo',
      auctionSubtypePlaceholder: 'Selecione o subtipo',
      auctionDamageLabel: 'Nível de Danos',
      auctionDamagePlaceholder: 'Selecione o nível de danos',
      damageLevelLabel: 'Nível de Danos',
      damageLevelPlaceholder: 'Selecione o nível de danos',
      auctionImportantTitle: 'Importante:',
      auctionImportantMessage: 'Informações de leilão são relevantes para transparência com o cliente. Sempre informe se o veículo veio de leilão e o nível de danos, se houver.',
      importanceTitle: 'Importante:',
      importanceMessage: 'Informações de leilão são relevantes para transparência com o cliente. Sempre informe se o veículo veio de leilão e o nível de danos, se houver.',
      descriptionTitle: 'Descrição do Veículo',
      descriptionLabel: 'Descrição',
      descriptionPlaceholder: 'Ex: Veículo em excelente estado de conservação, único dono, todas as revisões em dia, manual e chave reserva...',
      descriptionDescription: 'Descreva o veículo de forma atrativa e detalhada',
      descriptionSubtitle: 'Descreva o veículo de forma atrativa e detalhada',
      descriptionHint: 'Mínimo 10 caracteres. Destaque os principais diferenciais.',
      descriptionTipTitle: 'Dica:',
      tipTitle: 'Dica:',
      descriptionTipMessage: 'Uma boa descrição aumenta as chances de venda. Mencione:',
      tipMessage: 'Uma boa descrição aumenta as chances de venda. Mencione:',
      descriptionTipConservation: 'Estado de conservação do veículo',
      tip1: 'Estado de conservação do veículo',
      descriptionTipMaintenance: 'Histórico de manutenção e revisões',
      tip2: 'Histórico de manutenção e revisões',
      descriptionTipDifferentials: 'Principais diferenciais e opcionais',
      tip3: 'Principais diferenciais e opcionais',
      descriptionTipDocumentation: 'Documentação regularizada',
      tip4: 'Documentação regularizada',
      descriptionTipTradeOrFinance: 'Aceita troca ou financiamento (se aplicável)',
      tip5: 'Aceita troca ou financiamento (se aplicável)',
      descriptionHintEdit: 'Destaque os principais diferenciais e o estado de conservação',
    },
    summary: {
      title: 'Resumo Final — Revise as Informações',
      description: 'Revise todas as informações antes de finalizar o cadastro',
      readyTitle: 'Pronto para salvar!',
      readyMessage: 'Revise todas as informações abaixo antes de finalizar o cadastro.',
      basicSectionTitle: 'Informações Básicas',
      valuesSectionTitle: 'Valores',
      technicalSectionTitle: 'Especificações Técnicas',
      documentationSectionTitle: 'Documentação',
      descriptionSectionTitle: 'Descrição',
      mediaSectionTitle: 'Mídias',
      nameLabel: 'Nome',
      brandLabel: 'Marca',
      modelLabel: 'Modelo',
      conditionLabel: 'Condição',
      modelYearAndManufactureYearLabel: 'Ano Modelo / Fabricação',
      colorLabel: 'Cor',
      mileageLabel: 'Quilometragem',
      salePriceLabel: 'Preço de Venda',
      minimumPriceLabel: 'Preço Mínimo',
      purchasePriceLabel: 'Valor Pago',
      statusLabel: 'Status',
      fuelLabel: 'Combustível',
      transmissionLabel: 'Transmissão',
      typeLabel: 'Tipo',
      doorsLabel: 'Portas',
      steeringLabel: 'Direção',
      busBodyBrandLabel: 'Marca Carroceria',
      busBodyModelLabel: 'Modelo Carroceria',
      busOperationTypeLabel: 'Operação',
      busFleetNumberLabel: 'Nº Frota',
      plateLabel: 'Placa',
      chassisLabel: 'Chassi',
      renavamLabel: 'RENAVAM',
      inspectionLabel: 'Vistoria',
      inspectionValuePrefix: 'Vistoriado em',
      inspectionDateMissing: 'Data não informada',
      auctionLabel: 'Leilão',
      auctionValue: 'Veículo de Leilão',
      descriptionLabel: 'Descrição do Veículo',
      photosLabel: 'Fotos',
      photoSelectedOne: '1 foto selecionada',
      photoSelectedMany: '{{count}} fotos selecionadas',
      videoLabel: 'Vídeo',
      warningTitle: 'Atenção:',
      warningMessage: 'Verifique todas as informações antes de finalizar. Você poderá editar essas informações posteriormente se necessário.',
    },
  },

  dashboard: {
    title: 'Dashboard',
    subtitle: 'Visão geral da sua concessionária',
    error: {
      load: 'Não foi possível carregar os dados do dashboard',
    },
    actions: {
      refresh: 'Atualizar',
      refreshing: 'Atualizando...',
      tryAgain: 'Tentar novamente',
    },
    stats: {
      vehicles: 'Veículos',
      leads: 'Leads',
      revenue: 'Faturamento',
      conversion: 'Conversão',
    },
    charts: {
      salesAndLeads: 'Vendas e Leads por Mês',
      sales: 'Vendas',
      leadStatus: 'Status dos Leads',
      noData: 'Nenhum dado disponível',
    },
    recentLeads: {
      title: 'Leads Recentes',
      empty: 'Nenhum lead recente',
    },
    analytics: {
      monthlyDescription: 'Comparativo mensal de geração de demanda e fechamento.',
      statusDescription: 'Distribuição atual dos leads por status comercial.',
      recentLeadsDescription: 'Últimas oportunidades recebidas pela equipe comercial.',
      units: 'Unidades',
      stockAging: {
        title: 'Stock Aging',
        description: 'Tempo de pátio por faixa',
        ranges: {
          upTo15: '0-15 dias',
          from16To30: '16-30 dias',
          from31To60: '31-60 dias',
          from61To90: '61-90 dias',
          over90: '+90 dias',
        },
      },
      leadSla: {
        title: 'Lead SLA',
        target: 'Meta de resposta WhatsApp',
        firstResponse: '1ª resposta',
        qualification: 'Qualificação',
        followUp: 'Follow-up',
      },
      salesFunnel: {
        title: 'Funil de Vendas Completo',
        description: 'Conversão por etapa',
        leads: 'Leads',
        qualified: 'Qualificados',
        proposals: 'Propostas',
        negotiation: 'Negociação',
        closed: 'Vendas',
      },
      leaderboard: {
        title: 'Leaderboard de Vendedores',
      },
      preparation: {
        title: 'Gargalos de Preparação',
        defaultStage: 'Preparação',
        documentation: 'Documentação',
        service: 'Oficina',
        detailing: 'Estética',
      },
    },
  },

  postSalesPipeline: {
    title: 'Esteira de vendas',
    subtitle: 'Vendas em pós-venda com fluxo guiado até o envio à preparação.',
    wizard: {
      nextPhase: 'Ir para a próxima fase',
      stepBack: 'Etapa anterior',
      backToList: 'Voltar à lista',
      persistStepError: 'Não foi possível atualizar a etapa da venda.',
    },
  },

  // Common actions
  actions: {
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    create: 'Criar',
    add: 'Adicionar',
    confirm: 'Confirmar',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    clear: 'Limpar',
    close: 'Fechar',
    view: 'Visualizar',
    duplicate: 'Duplicar',
    loading: 'Carregando...',
    submit: 'Enviar',
    update: 'Atualizar',
  },

  salesPipeline: {
    title: 'Esteira de venda',
    subtitle:
      'A posição na esteira é calculada com base no status da venda e da proposta. Selecione uma venda para visualizar.',
    selectSale: 'Venda',
    selectPlaceholder: 'Selecione uma venda',
    loadSaleError: 'Não foi possível carregar os dados da venda.',
    loadSalesError: 'Não foi possível carregar a lista de vendas.',
    currentStageTitle: 'Posição atual',
    cancelledSale: 'Esta venda está cancelada. A esteira ilustrativa não se aplica.',
    stagesExplainTitle: 'O que significa cada etapa',
    stages: {
      first_contact: 'Primeiro contato',
      qualification: 'Qualificação',
      vehicle_interest: 'Interesse no veículo',
      visit_test_drive: 'Visita / Test drive',
      proposal_sent: 'Proposta enviada',
      negotiation: 'Negociação',
      proposal_approved: 'Proposta aprovada',
      payment: 'Pagamento',
      sale_confirmed: 'Venda confirmada',
      preparation: 'Preparação',
      delivery: 'Entrega',
    },
    stageHelp: {
      first_contact:
        'Registro inicial do interesse do cliente: origem do lead, dados de contato e encaminhamento ao time comercial.',
      qualification:
        'Entendimento de perfil, necessidade, orçamento e viabilidade para direcionar o atendimento ao veículo adequado.',
      vehicle_interest:
        'Cliente demonstra interesse em modelos específicos; alinham-se preço, versão, equipamentos e disponibilidade em estoque.',
      visit_test_drive:
        'Visita à loja ou test drive para experiência direta com o veículo e confirmação de interesse.',
      proposal_sent:
        'Proposta formal com valores, condições de pagamento e prazos enviada ao cliente para análise.',
      negotiation:
        'Ajustes de valores, entrada, troca, acessórios ou prazos até convergir oferta e expectativa.',
      proposal_approved:
        'Cliente aceita a proposta; inicia-se a formalização e conferência documental antes do pagamento.',
      payment:
        'Recebimento conforme combinado (parcelas, financiamento, transferências) até quitar o valor da venda.',
      sale_confirmed:
        'Venda reconhecida no fluxo operacional após pagamento ou contrato; segue-se preparação do veículo.',
      preparation:
        'Checklist pós-venda: documentação, revisão, higienização e acessórios para deixar o veículo pronto.',
      delivery:
        'Entrega do veículo ao cliente com orientações de uso e encerramento formal deste ciclo de venda.',
    },
  },

  financialSales: {
    title: 'Vendas',
    tabs: {
      list: 'Lista',
      pipeline: 'Esteira de venda',
    },
    filters: 'Filtros',
    status: 'Status',
    startDate: 'Data inicial',
    endDate: 'Data final',
    startDatePlaceholder: 'Selecione a data inicial',
    endDatePlaceholder: 'Selecione a data final',
    clearFilters: 'Limpar filtros',
    loadError: 'Erro ao carregar vendas',
    empty: 'Nenhuma venda encontrada',
    statusAll: 'Todos',
    statusLabels: {
      open: 'Em aberto',
      waiting_payment: 'Aguardando pagamento',
      paid: 'Pago',
      in_preparation: 'Em preparação',
      ready_for_delivery: 'Pronto para entrega',
      delivered: 'Entregue',
      pending: 'Pendente',
      confirmed: 'Confirmada',
      cancelled: 'Cancelada',
    },
    viewProposal: 'Ver proposta',
    proposalCardTitle: 'Proposta',
    saleItemsTitle: 'Itens adicionais da venda',
    saleItemDescription: 'Descrição',
    saleItemQty: 'Qtd.',
    saleItemUnit: 'Unitário',
    saleItemTotal: 'Total',
    paymentFormLabel: 'Forma de pagamento',
    paymentFormPlaceholder: 'Selecione',
    paymentOptionLabel: 'Opção da forma',
    paymentOptionPlaceholder: 'Opcional',
    paymentOptionNone: 'Nenhuma',
    paymentFormColumn: 'Forma de pagamento',
    saleChargesTitle: 'Encargos financeiros',
    saleChargesEmpty: 'Nenhum encargo registrado nesta venda.',
    saleChargeNameColumn: 'Encargo',
    saleChargeValueColumn: 'Valor',
    saleBenefitsTitle: 'Benefícios da venda',
    saleBenefitsEmpty: 'Nenhum benefício registrado nesta venda.',
    saleBenefitNameColumn: 'Benefício',
    saleBenefitValueColumn: 'Valor aplicado',
    customerCard: {
      title: 'Cliente',
      email: 'E-mail',
      phone: 'Telefone',
      address: 'Endereço',
      notes: 'Observações',
    },
    vehicleCard: {
      title: 'Veículo',
      plate: 'Placa',
    },
    salespersonCard: {
      title: 'Vendedor',
    },
    leadSnapshot: {
      title: 'Histórico do lead (snapshot)',
      capturedAt: 'Registrado em',
      interestsTitle: 'Interesses em veículos',
      legacyVehicleTitle: 'Veículo vinculado ao lead (legado)',
      preferencesTitle: 'Preferências de busca',
      proposalsTitle: 'Propostas do lead',
      contactsTitle: 'Contatos no lead',
      emptySnapshot:
        'Snapshot do lead indisponível. Gere ou atualize uma proposta para preencher estes dados.',
      proposalColumns: {
        status: 'Status',
        value: 'Valor',
        final: 'Final',
        vehicle: 'Veículo',
        date: 'Data',
      },
      proposalStatus: {
        open: 'Aberta',
        in_negotiation: 'Em negociação',
        approved: 'Aprovada',
        rejected: 'Rejeitada',
        expired: 'Expirada',
      },
    },
    leadSnapshotValidation: {
      title: 'Conferência',
      vehicleNotInInterests:
        'O veículo desta venda não aparece na lista de interesses capturada do lead.',
      documentMismatch:
        'O documento do cliente difere do documento no snapshot do lead.',
      proposalVehicleMismatch:
        'O veículo da proposta vinculada difere do veículo atual desta venda.',
    },
    commissions: {
      edit: 'Editar valores',
      base: 'Base',
      percent: 'Percentual (%)',
      calculatedValue: 'Valor acordado / pago',
      fixedValueColumn: 'Valor fixo',
      fixedValueLabel: 'Valor fixo',
      mixedBreakdown: 'Valor {{fixed}} + {{percent}} (total em {{totalPercent}})',
      originalColumn: 'Original (regra)',
      agreedColumn: 'Acordado',
      differenceColumn: 'Diferença',
      saveSuccess: 'Comissão atualizada',
      saveLocalSuccess: 'Alteração aplicada em tela. Será salva ao marcar como paga.',
      saveCommissionEditSuccess:
        'Valores da comissão atualizados em tela (envio final ao marcar como paga). Bônus gravados no servidor.',
      saveError: 'Não foi possível atualizar a comissão',
      onlyPending: 'Só é possível editar comissões pendentes',
      invalidValues: 'Valores inválidos. Use números positivos.',
      mandatoryReadonly:
        'Esta comissão é obrigatória pela configuração e não pode ser editada.',
      mandatoryBadge: 'Obrigatória',
      remove: 'Remover',
      confirmStepCta: 'Confirmar comissões',
      confirmNoCommissionsCta: 'Comissões concluídas',
      stepConfirmHint:
        'Confirme após revisar (ou quando não houver linhas) para liberar a próxima fase do pós-venda.',
      stepConfirmedHint: 'Comissões confirmadas em {{date}}.',
      confirmStepSuccess: 'Passo de comissões confirmado.',
      confirmStepError: 'Não foi possível confirmar o passo de comissões.',
      deleteDialogTitle: 'Remover comissão',
      deleteDialogDescription:
        'A linha será excluída desta venda. A confirmação do passo de comissões será desfeita se já estivesse marcada.',
      deleteSuccess: 'Comissão removida.',
      deleteError: 'Não foi possível remover a comissão.',
      summaryVehicleValue: 'Valor do veículo',
      summaryCommissionsTotal: 'Total de comissões',
      summaryVehicleMinusCommissions: 'Valor do veículo - comissões',
      editAfterConfirm: 'Editar comissões',
      lockedAfterPreparation: 'Comissões bloqueadas após envio para a preparação.',
      payRequiresCommissionConfirmation:
        'Confirme as comissões desta venda antes de marcar como paga.',
      paymentRuleAfterInvoice: 'Após faturamento',
      paymentRuleAfterPayment: 'Após pagamento do cliente',
      bonusColumn: 'Bônus',
      bonusValuesColumn: 'Valores de bônus',
      totalWithBonusesColumn: 'Total (c/ bônus)',
      bonusSectionTitle: 'Bônus desta comissão',
      bonusAmountLabel: 'Valor',
      bonusLabelPlaceholder: 'Descrição do bônus',
      bonusAdd: 'Adicionar bônus',
      bonusRemove: 'Remover',
      bonusInvalid: 'Informe a descrição e um valor válido para o bônus.',
      bonusAddSuccess: 'Bônus adicionado.',
      bonusRemoveSuccess: 'Bônus removido.',
      bonusSaveError: 'Não foi possível salvar o bônus.',
    },
    commissionSettings: {
      title: 'Comissões nas vendas',
      applyStoreRules: 'Incluir regras de loja e gerente em todas as vendas',
      applyStoreHint:
        'Quando ativo, regras com “Aplicável a” Loja ou Gerente entram na geração automática de comissões em cada venda.',
      saveSuccess: 'Configuração salva.',
      saveError: 'Não foi possível salvar a configuração.',
    },
    fiscalExport: {
      title: 'Exportação fiscal (contabilidade)',
      description:
        'CNPJ da concessionária, dados fiscais e endereço da filial do veículo, cliente e veículo para NF-e (sem XML). Corrija pendências e baixe PDF ou JSON.',
      missingTitle: 'Itens faltantes',
      readyHint: 'Dados mínimos preenchidos para exportação.',
      downloadJson: 'Baixar JSON',
      downloadPdf: 'Baixar PDF',
      editDealership: 'Filiais e fiscal por filial',
      editVehicle: 'Editar veículo',
      editCustomer: 'Editar cliente',
      loadError: 'Não foi possível carregar a exportação fiscal.',
      pdfLoadError: 'Não foi possível gerar o PDF fiscal.',
      missing: {
        issuerCnpj: 'CNPJ do emitente',
        issuerLegalName: 'Razão social / nome fantasia do emitente',
        customerAddressStreet: 'Logradouro do cliente',
        customerAddressNumber: 'Número do cliente',
        customerAddressCity: 'Cidade do cliente',
        customerAddressState: 'UF do cliente',
        customerAddressZip: 'CEP do cliente',
        branchLinkVehicle: 'Filial: vincule o veículo da venda a uma filial com endereço completo',
        branchStateRegistration: 'IE da filial (cadastro da filial)',
        branchTaxRegime: 'Regime tributário da filial (cadastro da filial)',
        branchName: 'Nome da filial',
        branchNeighborhood: 'Bairro da filial',
        branchAddressStreet: 'Logradouro da filial',
        branchAddressNumber: 'Número da filial',
        branchAddressCity: 'Cidade da filial',
        branchAddressState: 'UF da filial',
        branchAddressZip: 'CEP da filial',
        customerDocument: 'CPF/CNPJ do cliente',
        customerCpf: 'CPF do cliente (11 dígitos)',
        customerCnpj: 'CNPJ do cliente (14 dígitos)',
        customerName: 'Nome do cliente',
        customerEmail: 'E-mail do cliente',
        customerPhone: 'Telefone do cliente',
        vehiclePlate: 'Placa',
        vehicleChassis: 'Chassi',
        vehicleRenavam: 'RENAVAM',
        vehicleFuel: 'Combustível',
        vehicleColor: 'Cor',
        itemNcm: 'NCM (padrão na filial do veículo, na concessionária ou FISCAL_DEFAULT_NCM)',
        itemCfop: 'CFOP (padrão na filial do veículo, na concessionária ou FISCAL_DEFAULT_CFOP)',
      },
      customerEdit: {
        title: 'Editar cliente',
        save: 'Salvar',
        back: 'Voltar',
        saveSuccess: 'Cliente atualizado.',
        saveError: 'Não foi possível salvar o cliente.',
        loadError: 'Não foi possível carregar o cliente.',
      },
    },
    commissionRuleForm: {
      stepBasic: 'Configuração básica',
      stepAdvanced: 'Regras avançadas',
      stepValidity: 'Vigência',
      activeRuleLabel: 'Regra ativa',
      nameRequired: 'Informe o nome da regra. Este campo é obrigatório.',
      ruleBonusTitle: 'Bônus da regra',
      ruleBonusHint:
        'Valores padrão copiados para cada comissão gerada por esta regra. Na venda, podem ser ajustados em Editar valores.',
      salespersonLabel: 'Vendedor da regra (opcional)',
      salespersonAll: 'Todos os vendedores',
      salespersonHint: 'Só gera comissão na venda se o vendedor da venda for o mesmo.',
      listSalespersonColumn: 'Vendedor',
      sharedAmongLabel: 'Regra compartilhada entre vendedores',
      sharedAmongHint:
        'Quando ativo, esta regra de vendedor vale para qualquer vendedor da venda (não exige vendedor específico).',
      sharedBadge: 'Compartilhada',
      paymentFormHint:
        'Se você escolher uma forma de pagamento, a regra só será considerada quando a venda incluir essa forma (nas parcelas da proposta).',
      tierFixBeforeContinue:
        'Ajuste as faixas de valor: intervalos inválidos ou sobrepostos. Não é possível continuar ou salvar até corrigir.',
      tierInvalidRange: 'O valor máximo deve ser maior que o mínimo.',
      tierOverlap: 'Esta faixa sobrepõe outra. Ajuste os limites para que não se cruzem.',
      tierEmpty: 'Adicione pelo menos uma faixa de valor.',
      vigenceStatusNone: 'Sem vigência',
      vigenceStatusFuture: 'Futura',
      vigenceStatusExpired: 'Expirada',
      vigenceStatusActive: 'Vigente',
      nameField: 'Nome',
      namePlaceholder: 'Ex.: Comissão padrão vendedor',
      descriptionField: 'Descrição',
      descriptionPlaceholder: 'Descreva o objetivo desta regra...',
      commissionKindLabel: 'Tipo de comissão',
      calculationModeLabel: 'Tipo de cálculo',
      percentSingle: 'Percentual fixo',
      tierMode: 'Faixas de valor',
      percentValueLabel: 'Percentual (%)',
      tiersTitle: 'Faixas de valor',
      addTierRow: 'Adicionar faixa',
      tierMin: 'Valor mínimo',
      tierMax: 'Valor máximo (opcional)',
      tierPercent: 'Percentual (%)',
      tierHintEmpty: 'Clique em "Adicionar faixa" para criar faixas de comissão.',
      fixedBlockLabel: 'Valor fixo',
      calculationBase: 'Base de cálculo',
      calcBaseVehicle: 'Valor do veículo',
      calcBaseProfit: 'Lucro',
      calcBaseFinanced: 'Valor financiado',
      applicableToField: 'Aplicável a',
      paymentRuleField: 'Regra de pagamento',
      mixedOption: 'Misto (% + fixo)',
      vehicleTypeField: 'Tipo de veículo',
      vehicleAll: 'Ambos',
      vehicleNew: 'Novo',
      vehicleUsed: 'Usado',
      paymentFormField: 'Forma de pagamento',
      paymentPlaceholder: 'Selecione uma forma de pagamento (opcional)',
      paymentNone: 'Nenhuma',
      maxCommissionField: 'Teto máximo de comissão',
      maxCommissionPlaceholder: 'Sem limite',
      maxCommissionHelp: 'Deixe em branco para não limitar o valor da comissão.',
      startAt: 'Data de início',
      endAt: 'Data de fim',
      validityHint: 'Deixe as datas em branco para que a regra não tenha prazo de vigência.',
      startPlaceholder: 'Selecione data e hora de início',
      endPlaceholder: 'Selecione data e hora de fim',
      createRuleCta: 'Criar regra',
      updateRuleCta: 'Atualizar regra',
    },
    commissionRulesPage: {
      listSubtitle: 'Gerencie percentuais, faixas e vigência das comissões da loja.',
      registeredRules: 'Regras cadastradas ({{count}})',
      emptyList: 'Nenhuma regra de comissão encontrada.',
      loadError: 'Não foi possível carregar as regras de comissão.',
      duplicateSuccess: 'Regra de comissão duplicada com sucesso.',
      duplicateError: 'Não foi possível duplicar a regra.',
      deleteSuccess: 'Regra excluída com sucesso.',
      deleteError: 'Não foi possível excluir a regra.',
      deleteTitle: 'Confirmar exclusão',
      deleteDescription:
        'Tem certeza que deseja excluir a regra "{{name}}"? Esta ação não pode ser desfeita.',
      duplicateTitle: 'Duplicar regra',
      duplicateDescription:
        'Deseja duplicar a regra "{{name}}"? A nova regra será criada como inativa.',
      formTitleNew: 'Nova regra de comissão',
      formTitleEdit: 'Editar regra de comissão',
      formSubtitleNew: 'Preencha os dados da nova regra de comissão.',
      formSubtitleEdit: 'Editando: {{name}}',
      filtersTitle: 'Filtros',
      filterStatus: 'Status',
      filterType: 'Tipo',
      filterApplicable: 'Aplicável a',
      filterVigence: 'Vigência',
      allMasc: 'Todos',
      allFem: 'Todas',
      activeRules: 'Ativas',
      inactiveRules: 'Inativas',
      vigenceCurrent: 'Vigente',
      vigencePast: 'Expirada',
      colName: 'Nome',
      colType: 'Tipo',
      colValue: 'Valor / %',
      colApplicable: 'Aplicável a',
      colStatus: 'Status',
      colVigence: 'Vigência',
      colActions: 'Ações',
      statusOn: 'Ativa',
      statusOff: 'Inativa',
      bonusDash: '—',
      saveRuleError: 'Não foi possível salvar a regra de comissão.',
      createSuccess: 'Regra de comissão criada com sucesso.',
      updateSuccess: 'Regra de comissão atualizada com sucesso.',
    },
    commissionRuleEvaluation: {
      sectionTitle: 'Regras ativas nesta venda',
      notApplicable: 'Regra não aplicável',
      enabledOnSale: 'Habilitada nesta venda',
      onSaleColumn: 'Na venda',
      ruleColumn: 'Regra',
      statusColumn: 'Situação',
      applicableToColumn: 'Aplicável a',
      availableToAddHint: 'Disponível para adicionar manualmente.',
      reasons: {
        inactive: 'Regra inativa.',
        vehicle_type: 'O tipo de veículo da venda não corresponde ao definido na regra.',
        payment_form: 'A forma de pagamento da venda não corresponde à regra.',
        vigence_before_start: 'A vigência da regra ainda não começou.',
        vigence_after_end: 'A vigência da regra já encerrou.',
        salesperson_scope: 'O vendedor da venda não corresponde ao vendedor definido na regra.',
      },
      info: {
        manager_dealership_auto_disabled:
          'Não entra na geração automática enquanto a opção de incluir regras de loja e gerente estiver desligada; ainda pode ser adicionada manualmente.',
      },
      applicableTo: {
        salesperson: 'Vendedor',
        manager: 'Gerente',
        dealership: 'Loja',
      },
      mandatoryWillApplyHint:
        'Regra obrigatória: será considerada na geração automática quando os critérios forem atendidos.',
      noRulesInSelect: 'Nenhuma regra disponível',
    },
    preparationCostsTitle: 'Custos de preparação',
    preparationCostsAdd: 'Adicionar custo',
    preparationCostsDescription: 'Descrição',
    preparationCostsDescriptionPlaceholder: 'Descrição do custo',
    preparationCostsAmount: 'Valor',
    preparationCostsType: 'Tipo',
    preparationCostsTypePlaceholder: 'Selecione',
    preparationCostsEmpty: 'Nenhum custo de preparação registrado',
    costTypes: {
      mechanical: 'Mecânica',
      bodywork: 'Funilaria',
      documentation: 'Documentação',
      cleaning: 'Limpeza',
      accessories: 'Acessórios',
      other: 'Outros',
    },
    paymentsTab: {
      summaryTitle: 'Resumo de pagamentos',
      finalValue: 'Valor final da venda',
      totalConfirmed: 'Recebido (confirmado)',
      totalPending: 'Planejado (pendente)',
      remaining: 'Falta receber',
      fullyPaidBadge: 'Valor total recebido',
      proposalReference: 'Condições de pagamento (proposta)',
      installmentsCount: '{{count}} parcela(s)',
      dueDate: 'Vencimento',
      amount: 'Valor',
      status: 'Status',
      tradeTitle: 'Veículos na troca (proposta)',
      tradeMismatchHint:
        'Se o valor avaliado na loja for diferente do registrado na proposta, cancele esta venda e crie uma nova proposta com os valores corretos.',
      vehicle: 'Veículo',
      offeredValue: 'Valor na proposta',
      cancelSaleCta: 'Cancelar venda e refazer negociação',
      cancelSaleHint: 'Para corrigir valores após divergência na troca ou no negócio, cancele a venda e gere uma nova proposta.',
      cancelSaleTitle: 'Cancelar venda',
      cancelSaleDescription:
        'A venda será marcada como cancelada. Crie uma nova proposta para o cliente com os valores atualizados.',
      cancelSaleConfirm: 'Cancelar venda',
      cancelSaleSuccess: 'Venda cancelada',
      cancelSaleError: 'Não foi possível cancelar a venda',
      chargesTitle: 'Encargos na venda',
      chargeValue: 'Valor',
      discountPct: 'Desconto %',
      invoicePayments: 'Pagamentos de faturas',
      invoiceNumber: 'Fatura #{{n}}',
      date: 'Data',
      method: 'Método',
      saleReceipts: 'Recebimentos da venda',
      addReceipt: 'Adicionar recebimento',
      paidDate: 'Data do pagamento',
      registerAsPending: 'Registrar como pendente (ainda não recebido)',
      noReceipts: 'Nenhum recebimento registrado',
      statusPending: 'Pendente',
      statusConfirmed: 'Confirmado',
      statusCancelled: 'Cancelado',
      splitTitle: 'Dividir recebimento',
      splitDescription: 'Informe dois valores que somem o total da linha original. Novas linhas ficam pendentes.',
      splitPart1: 'Valor parcela 1',
      splitPart2: 'Valor parcela 2',
      splitConfirm: 'Dividir',
      deleteTitle: 'Excluir recebimento',
      deleteDescription: 'Excluir esta linha pendente? Esta ação não pode ser desfeita.',
      deleteSuccess: 'Recebimento excluído',
      deleteError: 'Não foi possível excluir',
      splitSuccess: 'Recebimento dividido',
      splitError: 'Não foi possível dividir',
      savePaymentSuccess: 'Recebimento atualizado',
      savePaymentError: 'Não foi possível atualizar',
      addPaymentSuccess: 'Recebimento registrado',
      addPaymentError: 'Não foi possível registrar',
      invalidAmount: 'Informe um valor numérico válido',
      invalidDiscount: 'Desconto deve ser entre 0 e 100%',
      chargeSaveSuccess: 'Encargo atualizado',
      chargeSaveError: 'Não foi possível atualizar o encargo',
    },
    saleDetailDates: {
      performedOn: 'Realizada em',
      registeredOn: 'Cadastrada em',
      saleDateField: 'Data da venda',
      registeredAtField: 'Data de cadastro',
    },
    saleDetailsTabs: {
      details: 'Detalhes',
      administrative: 'Administrativo',
      preparation: 'Preparação',
      operation: 'Esteira',
      timeline: 'Linha do tempo',
      financial: 'Financeiro',
      commissions: 'Comissões',
      payments: 'Pagamentos',
      documents: 'Documentos',
    },
    saleOnboarding: {
      title: 'Caminho até a esteira de preparação',
      subtitle:
        'Siga a ordem: a próxima etapa só fica disponível quando todas as anteriores estiverem concluídas.',
      loading: 'Carregando progresso…',
      syncing: 'Sincronizando com o servidor…',
      lockedStepHint: 'Conclua as etapas anteriores primeiro.',
      tabLockedToast: 'Conclua as etapas anteriores para abrir esta aba.',
      steps: {
        payment: 'Pagamento',
        documentation: 'Documentação',
        commissions: 'Comissionamento',
        invoicing: 'Faturamento',
        pipeline: 'Pronto para preparação',
      },
      sendCta: 'Enviar para a esteira de preparação',
      sending: 'Enviando…',
      sendSuccess: 'Venda enviada para preparação.',
      sendError: 'Não foi possível enviar para a esteira.',
      hintCompleteRequirements:
        'Complete pagamento, documentação, comissões obrigatórias, faturamento (NF-e ou fatura) e o checklist pós-venda.',
      inPipeline: 'Esta venda já está na esteira de preparação ou em etapa seguinte.',
      requirementsTitle: 'Requisitos de documentação e contratos',
      customerDocsSection: 'Documentos obrigatórios',
      contractsSection: 'Contratos obrigatórios',
      attachCustomer: 'Vínculo: cadastro do cliente',
      attachSale: 'Vínculo: documentos da venda',
      selectDocument: 'Selecione o arquivo',
      linkDocument: 'Vincular',
      linking: 'Vinculando…',
      docLinked: 'Documento vinculado.',
      docLinkError: 'Não foi possível vincular o documento.',
      pickDocumentFirst: 'Selecione um documento na lista.',
      uploadFirstHint: 'Envie o arquivo abaixo e volte aqui para vincular.',
      uploadCustomerTitle: 'Enviar documento do cliente',
      openTemplate: 'Abrir modelo de referência',
      signDate: 'Data da assinatura',
      signedPdfOptional: 'PDF assinado (opcional)',
      optional: 'Opcional',
      none: 'Nenhum',
      saving: 'Salvando…',
      confirmSignature: 'Registrar assinatura',
      contractSigned: 'Assinatura registrada.',
      contractSignError: 'Não foi possível registrar a assinatura.',
      pickSignDate: 'Informe a data da assinatura.',
    },
    saleDocumentation: {
      tabSaleDocs: 'Documentos da venda',
      tabVehicle: 'Documentos do veículo',
      tabContracts: 'Contratos assinados',
      saleUploadTitle: 'Upload de documentos',
      saleListTitle: 'Documentos da venda',
      documentationAccordionChecklist: 'Checklist de documentação',
      documentationAccordionUploadsHint:
        'Checklist no primeiro bloco. Em seguida, cada tipo lista o que já foi enviado nesta venda e permite novo upload.',
      slotFileCount: '{{count}} arquivo(s)',
      slotUploadedListLabel: 'Arquivos desta venda (este tipo)',
      slotNoFilesYet: 'Nenhum arquivo deste tipo ainda.',
      checklistTitle: 'Checklist de documentação',
      vehicleMandatoryTitle: 'Arquivos da documentação desta venda',
      vehicleListTitle: 'Documentos do cadastro do veículo',
      vehicleRegistryHint:
        'Apenas documentos já cadastrados na ficha do veículo. Para o processo desta venda, use a aba Documentos da venda.',
      vehicleRegistryEmpty: 'Nenhum documento no cadastro do veículo.',
      uploadSlot: 'Enviar arquivo',
      readOnlyHint: 'Sem permissão para alterar.',
      noVehicle: 'Esta venda não possui veículo vinculado.',
      noContracts: 'Nenhum modelo de contrato configurado para esta concessionária.',
      uploadSaleContractTitle: 'Contrato assinado (arquivo)',
      uploadSignedContract: 'Enviar PDF do contrato assinado',
      signedBadge: 'Assinado',
      pendingBadge: 'Pendente',
      updateSignature: 'Atualizar assinatura',
      invoiceSyncedHint: 'Concluído automaticamente quando NF-e autorizada ou fatura emitida.',
      checklistSaved: 'Checklist atualizado.',
      checklistCleared: 'Item desmarcado.',
      checklistError: 'Não foi possível atualizar o checklist.',
      deleteError: 'Não foi possível remover o documento.',
      checklistUploadRequiredHint:
        'Só é possível marcar um item após existir arquivo enviado correspondente (upload). A nota fiscal é sincronizada automaticamente.',
      checklistBadgeRequired: 'Obrigatório nesta etapa',
      checklistBadgeRecommended: 'Recomendado',
      checklistBadgeSend: 'Obrigatório para enviar à preparação',
      checklistAtpvHint:
        'No Detran pode valer ATPV-e; para segurança jurídica, guarde comprovação com duas assinaturas (recibo, TED/PIX, contrato de compra e venda, etc.).',
      pjCorporateBanner:
        'Pessoa jurídica: envie CNPJ, contrato social e documento do responsável nos cartões acima (obrigatório para avançar).',
      slotOptionalHint: 'opcional nesta etapa',
      checklistKeys: {
        buyer_id: 'Documento do comprador (RG/CPF ou CNPJ)',
        address_proof: 'Comprovante de endereço',
        atpv_signed: 'ATPV / prova jurídica (duas assinaturas)',
        invoice_issued: 'Nota fiscal emitida',
        inspection_done: 'Vistoria realizada',
        transfer_fee_paid: 'Taxa de transferência paga',
        sent_to_dispatcher: 'Transferência enviada ao despachante',
      },
      slotRgCpf: 'RG e CPF',
      slotCnpj: 'CNPJ',
      slotArticles: 'Contrato social',
      slotResponsible: 'Documento do responsável',
      slotAddressProof: 'Comprovante de endereço',
      slotAtpv: 'ATPV assinada',
      slotInspection: 'Laudo de vistoria',
      slotPaymentFees: 'Comprovante de pagamentos e taxas',
      slotDebts: 'Comprovante de quitação (IPVA, multas, débitos)',
      slotTransferFee: 'Comprovante taxa de transferência',
      slotDispatcherProof: 'Comprovante envio ao despachante',
      documentUpload: {
        defaultLabel: 'Upload de documento',
        selectFile: 'Selecionar arquivo',
        changeFile: 'Escolher outro',
        cancelSelection: 'Cancelar',
        confirmUpload: 'Enviar documento',
        uploading: 'Enviando…',
        previewPdf: 'Pré-visualização PDF',
        previewOther: 'Pré-visualização não disponível para este tipo. Confira o nome do arquivo e envie.',
        tempFailed: 'Falha no upload temporário do arquivo',
        saleIdRequired: 'saleId é obrigatório para enviar documentos desta entidade',
        invalidTempResponse: 'Resposta de upload inválida',
      },
    },
    saleLifecycle: {
      phases: {
        payment: 'Pagamento',
        documentation: 'Documentação',
        commissions: 'Comissionamento',
        invoicing: 'Faturamento',
        ready_for_preparation: 'Pronto para preparação',
        quality_control: 'Controle de qualidade',
        ready_for_delivery: 'Pronto para entrega',
      },
      lifecycleChecklistsTitle: 'Checklist por fase',
      lifecycleOpenTab: 'Abrir etapa',
      lifecycleDone: 'Concluído',
      lifecyclePending: 'Pendente',
      lifecycleCancelledHint: 'Venda cancelada — sem checklist de lifecycle.',
      administrativeAdvancedTitle: 'Etapas administrativas (avançado)',
      administrativeTitle: 'Etapas administrativas',
      administrativeField: 'Etapa administrativa',
      macroPreparationField: 'Etapa de preparação (macro)',
      preparationTitle: 'Tarefas de preparação',
      timelineTitle: 'Linha do tempo',
      saveStages: 'Salvar etapas',
      stagesSaved: 'Etapas atualizadas',
      stagesError: 'Não foi possível salvar as etapas',
      noTasks: 'Nenhuma tarefa. Use “Iniciar preparação” quando a venda estiver paga para gerar o checklist.',
      taskStep: 'Etapa',
      taskStatus: 'Status',
      saveTask: 'Salvar',
      taskSaved: 'Tarefa atualizada',
      taskError: 'Erro ao atualizar tarefa',
      timelineEmpty: 'Sem eventos',
      timelineLoadError: 'Erro ao carregar a linha do tempo',
      adminStages: {
        sale_created: 'Venda criada',
        documentation_pending: 'Documentação pendente',
        documentation_received: 'Documentação recebida',
        financing_in_progress: 'Financiamento em andamento',
        financing_complete: 'Financiamento concluído',
        commission_pending: 'Comissão pendente',
        commission_complete: 'Comissão quitada',
        ready_for_preparation: 'Pronto para preparação',
      },
      prepStages: {
        not_started: 'Não iniciada',
        preparation_pending: 'Preparação pendente',
        mechanical_check: 'Revisão mecânica',
        detailing: 'Detalhamento',
        accessories_installation: 'Instalação de acessórios',
        document_transfer: 'Transferência documental',
        delivery_scheduled: 'Entrega agendada',
        completed: 'Concluída',
      },
      taskStatuses: {
        pending: 'Pendente',
        in_progress: 'Em andamento',
        completed: 'Concluída',
        skipped: 'Ignorada',
      },
      stepKeys: {
        mechanical_check: 'Revisão mecânica',
        detailing: 'Detalhamento',
        accessories_installation: 'Acessórios',
        document_transfer: 'Documentação / transferência',
        delivery_scheduled: 'Entrega agendada',
        other: 'Outro',
      },
      timelineEventTitles: {
        lead_history: 'Atividade do lead',
        proposal_created: 'Proposta criada',
        proposal_sent: 'Proposta enviada',
        proposal_approved: 'Proposta aprovada',
        sale_created: 'Venda registrada',
        sale_status_history: 'Status da venda',
        entity_document: 'Documento (venda)',
        vehicle_entity_document: 'Documento (veículo)',
        sale_payment_recorded: 'Pagamento da venda',
        commission: 'Comissão',
        sale_cost: 'Custo de preparação',
        preparation_task_created: 'Tarefa de preparação',
        preparation_task_completed: 'Tarefa concluída',
        operational_stage_change: 'Etapa operacional',
        preparation_kanban_change: 'Quadro de preparação',
        checklist_item_change: 'Checklist',
      },
    },
  },

  operation: {
    stages: {
      pos_venda: 'Pós-venda',
      preparacao: 'Preparação',
      entrega: 'Entrega',
      pos_recebimento: 'Pós-recebimento',
      concluido: 'Concluído',
    },
    postSale: {
      title: 'Pós-venda',
      subtitle: 'Documentação e financeiro antes da preparação do veículo.',
    },
    preparation: {
      title: 'Preparação',
      subtitle: 'Kanban da oficina — arraste os cards entre as colunas.',
    },
    preparationDetail: {
      title: 'Detalhe da preparação',
      subtitle: 'Acompanhamento operacional do veículo em preparação.',
      backToBoard: 'Voltar para o kanban',
      loadError: 'Não foi possível carregar o detalhe da preparação.',
      notFound: 'Detalhe da preparação não encontrado.',
      vehicleSectionTitle: 'Dados do veículo',
      vehicleLabel: 'Veículo',
      plate: 'Placa',
      year: 'Ano',
      mileage: 'Quilometragem',
      customer: 'Cliente',
      kanbanColumn: 'Coluna do kanban',
      operationalCommentLabel: 'Comentário da operação',
      operationalCommentPlaceholder: 'Registre observações sobre o andamento desta operação.',
      timeInColumn: 'Tempo nesta coluna',
      columnSince: 'Entrada na coluna',
      checklistSectionTitle: 'Checklist da preparação',
      checklistProgress: '{{done}} de {{total}} concluídos',
      saveChecklist: 'Salvar checklist',
      checklistSaved: 'Checklist atualizado.',
      checklistError: 'Não foi possível atualizar o checklist.',
      tasksSectionTitle: 'Tarefas da preparação',
      selectAssignee: 'Selecione um responsável',
      onlyUnassigned: 'Aplicar apenas em tarefas sem responsável',
      applyAssigneeToFlow: 'Aplicar responsável no fluxo',
      assigneeSaved: 'Responsável da tarefa atualizado.',
      assigneeError: 'Não foi possível atualizar o responsável.',
      bulkAssignSaved: 'Responsável aplicado nas tarefas.',
      bulkAssignError: 'Não foi possível aplicar responsável nas tarefas.',
      saveAllSuccess: 'Alterações salvas com sucesso.',
      saveAllError: 'Não foi possível salvar as alterações.',
      deliveryDateLabel: 'Data de entrega',
      deliveryDatePlaceholder: 'Selecionar data e horário',
      deliveryAtSaved: 'Data de entrega agendada.',
      saveAll: 'Salvar',
      confirmDelivery: 'Confirmar entrega',
      confirmDeliveryTitle: 'Confirmar entrega do veículo',
      confirmDeliveryDescription: 'Deseja realmente finalizar esta entrega? Esta ação marcará a venda como entregue e o veículo como vendido.',
      confirmDeliveryWarning: 'Após confirmar, o veículo será considerado entregue e a venda será finalizada.',
      confirmDeliveryConfirm: 'Sim, confirmar entrega',
      confirmDeliveryCancel: 'Cancelar',
      deliveryConfirmed: 'Entrega confirmada com sucesso!',
      deliveryConfirmError: 'Não foi possível confirmar a entrega.',
      noTasks: 'Nenhuma tarefa de preparação cadastrada.',
      unassigned: 'Sem responsável',
      tabFlow: 'Fluxo',
      tabDocuments: 'Documentos',
      tabComments: 'Comentários',
      documentsTitle: 'Documentos da preparação',
      documentUploaded: 'Documento enviado com sucesso.',
      noDocuments: 'Nenhum documento enviado.',
      uploadedDocuments: '{{count}} documento(s) enviado(s)',
      saveComment: 'Salvar comentário',
      commentSaved: 'Comentário salvo.',
    },
    deliveries: {
      title: 'Entregas',
      subtitle: 'Veículos prontos para entrega ao cliente.',
    },
    postReceipt: {
      title: 'Pós-recebimento',
      subtitle: 'Acompanhamento após a entrega.',
    },
    loadError: 'Não foi possível carregar as vendas.',
    refresh: 'Atualizar',
    list: {
      date: 'Data',
      customer: 'Cliente',
      vehicle: 'Veículo',
      finalValue: 'Valor final',
      progress: 'Checklist',
      details: 'Detalhes',
      actions: 'Ações',
      pageOf: 'Página {{page}} de {{total}}',
    },
    empty: 'Nenhuma venda nesta etapa.',
    salesInStage: 'Vendas nesta etapa',
    value: 'Valor',
    checklistProgress: '{{pct}}% do checklist',
    advance: 'Avançar etapa',
    advanceOk: 'Etapa atualizada.',
    advanceError: 'Não foi possível avançar a etapa.',
    timeline: {
      title: 'Linha do tempo',
      empty: 'Nenhum comentário ou evento registrado ainda.',
      newCommentPlaceholder: 'Escreva um comentário…',
      addComment: 'Adicionar comentário',
      commentAdded: 'Comentário adicionado.',
      kanbanMoved: '{{actor}} moveu o card no quadro de preparação: {{from}} → {{to}}',
      operationalStage: '{{actor}} alterou a etapa operacional: {{from}} → {{to}}',
      preparationStage: '{{actor}} alterou a etapa de preparação: {{from}} → {{to}}',
      checklist: '{{actor}} — {{title}}: {{action}}',
      checklistActionCompleted: 'concluído',
      checklistActionReopened: 'reaberto',
      checklistActionNotes: 'observações atualizadas',
      unknownEvent: 'Atividade registrada',
    },
    kanban: {
      boardTitle: 'Preparação',
      timeInColumn: 'Tempo na coluna',
      moved: 'Card atualizado.',
      moveError: 'Não foi possível mover o card.',
      moveOnlyAdjacent: 'Só é permitido mover para a coluna imediatamente anterior ou próxima.',
      cannotMoveBackFromLast: 'Após chegar na última coluna, não é possível voltar para etapas anteriores.',
      deliveryAtRequiredPrompt:
        'Informe a data e hora da entrega para entrar na última coluna (formato: AAAA-MM-DDTHH:mm).',
      deliveryAtInvalid: 'Data de entrega inválida.',
      columnResponsible: 'Responsável: {{name}}',
      columnResponsibleEmpty: 'Sem responsável',
      bayRequiresAssignee:
        'Para enviar à baia, atribua todas as tarefas de preparação a um usuário ou defina o responsável pela entrega na venda.',
      noColumns: 'Configure o kanban para funcionar nesta etapa.',
      nextPhase: 'Próxima fase',
      responsible: 'Responsável',
      multipleAssignees: 'Vários responsáveis',
      swipeHint: 'Deslize horizontalmente para ver as colunas.',
      columns: {
        awaiting_preparation: 'Aguardando',
        in_preparation: 'Em preparação',
        quality_control: 'Controle de qualidade',
        ready_for_delivery_handoff: 'Pronto para entrega',
      },
    },
    delivery: {
      scheduledAt: 'Data da entrega',
      responsible: 'Responsável',
    },
    saleDetail: {
      checklistTitle: 'Checklist da etapa atual',
      checklistEmpty: 'Nenhum item de checklist. Configure um modelo em templates.',
      configureCheckpoints: 'Configurar checkpoints de pós-venda',
      checklistSaved: 'Checklist atualizado.',
      checklistError: 'Erro ao atualizar checklist.',
      advance: 'Avançar para a próxima etapa',
      advanceOk: 'Etapa avançada.',
      advanceError: 'Não foi possível avançar.',
      deliveryTitle: 'Dados da entrega',
      deliveryAt: 'Data e hora da entrega',
      deliverySaved: 'Dados de entrega salvos.',
      deliveryError: 'Erro ao salvar entrega.',
    },
  },

  common: {
    name: 'Nome',
    brand: 'Marca',
    model: 'Modelo',
    color: 'Cor',
    mileage: 'Quilometragem',
    condition: 'Condição',
    fuel: 'Combustível',
    transmission: 'Transmissão',
    doors: 'Portas',
    steering: 'Direção',
    bodyBrand: 'Marca Carroceria',
    bodyModel: 'Modelo Carroceria',
    operation: 'Operação',
    fleetNumber: 'Nº Frota',
    salePrice: 'Preço de Venda',
    purchasePrice: 'Preço de Compra',
    photos: 'Fotos',
    video: 'Vídeo',
    km: 'km',
    warning: 'Atenção',
    description: 'Descrição',
    status: 'Status',
    date: 'Data',
    price: 'Preço',
    type: 'Tipo',
    category: 'Categoria',
    notes: 'Observações',
    note: 'Nota',
    active: 'Ativo',
    inactive: 'Inativo',
    yes: 'Sim',
    no: 'Não',
    all: 'Todos',
    none: 'Nenhum',
    never: 'Nunca',
    optional: 'Opcional',
    required: 'Obrigatório',
    total: 'Total',
    notProvided: 'Não informado',
    continueEditing: 'Continuar editando',
    loading: 'Carregando...',
    noResults: 'Nenhum resultado encontrado',
    typeAtLeastChars: 'Digite pelo menos {{count}} caracteres',
    min: 'Mínimo',
    max: 'Máximo',
    days: {
      monday: 'Seg',
      tuesday: 'Ter',
      wednesday: 'Qua',
      thursday: 'Qui',
      friday: 'Sex',
      saturday: 'Sáb',
      sunday: 'Dom',
    },
  },

  // Vehicles
  vehicles: {
    title: 'Veículos',
    subtitle: 'Gerencie o estoque da sua concessionária',
    new: 'Novo Veículo',
    edit: 'Editar Veículo',
    details: 'Detalhes do Veículo',
    list: 'Lista de Veículos',
    brand: 'Marca',
    model: 'Modelo',
    version: 'Versão',
    year: 'Ano',
    mileage: 'Quilometragem',
    color: 'Cor',
    condition: 'Condição',
    fuelType: 'Combustível',
    transmission: 'Transmissão',
    doors: 'Portas',
    branch: 'Filial',
    selectBranch: 'Selecione uma filial',
    loadingBranches: 'Carregando filiais...',
    registration: {
      selectVehicleTypeTitle: 'Selecione o tipo de veículo',
      vehicleCategoryLabel: 'Categoria do veículo *',
      selectBranchFirst: 'Selecione primeiro a filial para ver as categorias permitidas.',
      noBranchesHint: 'Nenhuma filial disponível. Cadastre uma filial em Configurações da concessionária.',
      noCategoriesForBranch: 'Esta filial não tem categorias habilitadas. Ajuste em Configurações da concessionária.',
      categoryLabels: {
        A: 'Moto',
        B: 'Carro',
        C: 'Caminhão',
        D: 'Ônibus',
      },
    },
    validation: {
      branchRequired: 'Selecione a filial do veículo',
      categoryRequired: 'Categoria do veículo é obrigatória',
      categoryNotAllowedForBranch: 'Esta categoria não está habilitada para a filial selecionada',
    },
    salePrice: 'Preço de Venda',
    purchasePrice: 'Preço de Compra',
    vehicleStatus: {
      in_stock: 'Em Estoque',
      reserved: 'Reservado',
      sold: 'Vendido',
      in_transit: 'Em Trânsito',
    },
    vehicleCondition: {
      new_vehicle: '0 KM',
      semi_new: 'Semi-novo',
      used: 'Usado',
    },
    filters: { title: 'Filtros', clear: 'Limpar' },
    noVehicles: 'Nenhum veículo encontrado',
    photos: 'Fotos',
    features: 'Características',
    marketplaces: 'Publicações em Marketplaces',
    published: 'Publicado',
    publish: 'Publicar',
    success: {
      published: 'Veículo publicado com sucesso!',
    },
    errors: {
      publish: 'Não foi possível publicar o veículo.',
    },
    // VehiclesPage (list)
    stats: {
      total: 'Total de Veículos',
      inStock: 'Em Estoque',
      totalValue: 'Valor Total',
    },
    status: {
      inStock: 'Em Estoque',
      reserved: 'Reservado',
      sold: 'Vendido',
      inTransit: 'Em Trânsito',
    },
    search: {
      placeholder: 'Buscar por nome, placa ou chassi...',
    },
    view: {
      grid: 'Grade',
      list: 'Lista',
    },
    results: {
      one: 'veículo encontrado',
      multiple: 'veículos encontrados',
      withFilters: ' com filtros ativos',
    },
    table: {
      vehicle: 'Veículo',
      year: 'Ano',
      price: 'Preço',
      status: 'Status',
      km: 'KM',
      actions: 'Ações',
    },
    actions: {
      addVehicle: 'Adicionar Veículo',
      register: 'Cadastrar Veículo',
      view: 'Visualizar',
      edit: 'Editar',
      delete: 'Excluir',
    },
    empty: {
      noVehicles: 'Nenhum veículo cadastrado',
      filters: 'Nenhum veículo encontrado',
      adjustFilters: 'Tente ajustar os filtros para ver mais resultados',
      addFirst: 'Adicione o primeiro veículo ao seu estoque',
    },
    noIdentification: 'Sem identificação',
    priceLabel: 'Preço de venda',
    category: 'Categoria',
    dialog: {
      deleteTitle: 'Confirmar Exclusão',
      deleteDescription: 'Tem certeza que deseja excluir "{{name}}"? Esta ação não pode ser desfeita.',
      thisVehicle: 'este veículo',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
    fields: {
      condition: 'Condição',
      category: 'Categoria',
    },
  },

  // Leads
  leads: {
    title: 'Leads',
    new: 'Novo Lead',
    edit: 'Editar Lead',
    details: 'Detalhes do Lead',
    clientInfo: 'Informações do Cliente',
    vehicleInterests: 'Veículos de Interesse',
    preferences: 'Preferências do Cliente',
    source: 'Origem',
    seller: 'Vendedor',
    autoTransfer: {
      title: 'Transferência Automática',
      description: 'Configure regras para transferir leads automaticamente',
      defaultSeller: 'Vendedor padrão (fallback)',
      defaultSellerHint:
        'Quando nenhuma regra for compatível com o lead, a atribuição usa este vendedor. Opcional.',
      defaultSellerNone: 'Sem vendedor padrão',
      defaultSellerSaved: 'Vendedor padrão atualizado.',
      defaultSellerError: 'Não foi possível salvar o vendedor padrão.',
      returnRuleTitle: 'Regra de retorno (obrigatória)',
      returnRuleHint:
        'Esta regra tem prioridade acima de todas as outras. Defina quando um lead pode retornar ao vendedor anterior.',
      alwaysReturn: 'Sempre retornar ao vendedor anterior',
      unitHours: 'Horas',
      unitDays: 'Dias',
      unitMonths: 'Meses',
      returnRuleSaved: 'Regra de retorno atualizada.',
      returnRuleError: 'Não foi possível salvar a regra de retorno.',
      returnRuleInvalid: 'Informe um valor inteiro maior que zero.',
      tabRules: 'Regras',
      tabHistory: 'Histórico',
      historyTitle: 'Histórico de alterações',
      historyEmpty: 'Nenhuma alteração registrada ainda.',
      historyLoadError: 'Não foi possível carregar o histórico.',
      historyOldValues: 'Antes',
      historyNewValues: 'Depois',
      historyActionToggle: 'Ativação da transferência automática',
      historyActionDefaultSeller: 'Vendedor padrão',
      historyActionReturnRule: 'Regra de retorno',
      historyActionRuleCreated: 'Regra criada',
      historyActionRuleUpdated: 'Regra atualizada',
      historyActionRuleDeleted: 'Regra removida',
      historyActionRulesReordered: 'Reordenação de regras',
      enabled: 'Ativado',
      addRule: 'Nova Regra',
      addFirstRule: 'Adicionar primeira regra',
      noRules: 'Nenhuma regra configurada',
      conditions: 'condições',
      inactive: 'Inativo',
      ruleName: 'Nome da Regra',
      ruleNamePlaceholder: 'Ex: Clientes de SP',
      assignedUsers: 'Vendedores',
      selectUsers: 'Selecione os vendedores',
      branch: 'Filial',
      selectBranch: 'Selecione a filial',
      allBranches: 'Todas as filiais',
      branchDesc: 'Regras são aplicadas apenas à filial selecionada',
      branches: 'Filiais',
      selectBranches: 'Selecione as filiais',
      branchesDesc: 'Selecione uma ou mais filiais. Deixe vazio para aplicar a todas.',
      searchUsers: 'Buscar vendedores',
      editRule: 'Editar Regra',
      newRule: 'Nova Regra',
      confirmDelete: 'Tem certeza que deseja excluir esta regra?',
      // Tipo de regra
      ruleType: 'Tipo de Regra',
      byCharacteristics: 'Por Características',
      bySpecificVehicles: 'Por Veículos Específicos',
      byCharacteristicsDesc: 'Distribua leads baseado em características como marca, modelo, preço, localização, etc.',
      bySpecificVehiclesDesc: 'Distribua leads baseado em veículos específicos do seu estoque.',
      selectVehicles: 'Selecione os veículos',
      searchVehicles: 'Buscar veículos',
      removeVehicle: 'Remover veículo',
      // Seções do formulário
      geographicFilters: 'Filtros Geográficos',
      geographicFiltersDesc: 'Defina regiões, cidades e bairros',
      vehicleFilters: 'Filtros de Veículo',
      vehicleFiltersDesc: 'Especifique características do veículo',
      priceAndRange: 'Faixas de Preço e Ano',
      priceAndRangeDesc: 'Defina limites de preço, ano e quilometragem',
      schedule: 'Horário de Atendimento',
      scheduleDesc: 'Defina dias e horários para distribuição',
      leadSources: 'Fontes de Lead',
      leadSourcesDesc: 'Selecione de quais fontes os leads serão distribuídos',
      // Campos geográficos
      regions: 'Regiões',
      regionsPlaceholder: 'Selecione as regiões',
      regionNorth: 'Norte',
      regionNortheast: 'Nordeste',
      regionMidwest: 'Centro-Oeste',
      regionSoutheast: 'Sudeste',
      regionSouth: 'Sul',
      states: 'Estados',
      selectStates: 'Selecione os estados',
      searchStates: 'Buscar estados',
      cities: 'Cidades',
      selectCities: 'Selecione as cidades',
      searchCities: 'Buscar cidades',
      selectStatesFirst: 'Selecione estados primeiro',
      citiesPlaceholder: 'Selecione as cidades',
      neighborhoods: 'Bairros',
      neighborhoodsPlaceholder: 'Digite os bairros',
      searchNeighborhoods: 'Buscar bairros',
      zipCodes: 'CEPs',
      zipCodesPlaceholder: 'Digite os CEPs',
      // Campos de veículo
      categories: 'Categorias',
      categoriesPlaceholder: 'Selecione as categorias',
      vehicleTypes: 'Tipos de Veículo',
      vehicleTypesPlaceholder: 'Selecione os tipos',
      vehicleConditions: 'Condição',
      vehicleConditionsPlaceholder: 'Novo, Usado, Seminovo',
      brands: 'Marcas',
      brandsPlaceholder: 'Selecione as marcas',
      selectCategoriesFirst: 'Selecione categorias primeiro',
      models: 'Modelos',
      modelsPlaceholder: 'Selecione os modelos',
      selectBrandsFirst: 'Selecione marcas primeiro',
      versions: 'Versões',
      versionsPlaceholder: 'Selecione as versões',
      fuelTypes: 'Combustível',
      fuelTypesPlaceholder: 'Selecione os tipos',
      transmissions: 'Transmissão',
      transmissionsPlaceholder: 'Selecione os tipos',
      colors: 'Cores',
      colorsPlaceholder: 'Selecione as cores',
      armorLevels: 'Níveis de Blindagem',
      armorLevelsPlaceholder: 'Selecione os níveis',
      // Faixas
      yearRange: 'Ano do Veículo',
      minYear: 'Ano Mínimo',
      maxYear: 'Ano Máximo',
      priceRange: 'Faixa de Preço',
      minPrice: 'Preço Mínimo',
      maxPrice: 'Preço Máximo',
      mileageRange: 'Quilometragem',
      minMileage: 'KM Mínima',
      maxMileage: 'KM Máxima',
      // Horário
      scheduleDays: 'Dias da Semana',
      scheduleStart: 'Horário Inicial',
      scheduleEnd: 'Horário Final',
      // Fontes
      sources: 'Fontes',
      sourcesPlaceholder: 'Selecione as fontes',
      leadSourceKeys: 'Chaves de Origem',
      leadSourceKeysPlaceholder: 'Digite as chaves',
      // Opções comuns
      new: 'Novo',
      used: 'Usado',
      // Mensagens de feedback
      ruleNameRequired: 'Nome da regra é obrigatório',
      selectUsersRequired: 'Selecione pelo menos um vendedor',
      ruleCreatedSuccess: 'Regra criada com sucesso!',
      ruleUpdatedSuccess: 'Regra atualizada com sucesso!',
      ruleSaveError: 'Erro ao salvar regra. Tente novamente.',
      reorderSuccess: 'Ordem das regras atualizada com sucesso!',
      reorderError: 'Erro ao reordenar regras. Tente novamente.',
      deleteRuleTitle: 'Excluir regra?',
      deleteRuleDescription: 'Tem certeza que deseja excluir a regra "{{name}}"? Esta ação não pode ser desfeita.',
      deleteRuleDescriptionGeneric: 'Tem certeza que deseja excluir esta regra? Esta ação não pode ser desfeita.',
      ruleDeletedSuccess: 'Regra excluída com sucesso!',
      deleteError: 'Erro ao excluir regra. Tente novamente.',
      certified: 'Seminovo Certificado',
      car: 'Carro',
      motorcycle: 'Moto',
      truck: 'Caminhão',
      gasoline: 'Gasolina',
      diesel: 'Diesel',
      electric: 'Elétrico',
      flex: 'Flex',
      hybrid: 'Híbrido',
      manual: 'Manual',
      automatic: 'Automático',
      cvt: 'CVT',
      automatedManual: 'Automatizada',
    },
    form: {
      personTypePF: 'Pessoa Física',
      personTypePJ: 'Pessoa Jurídica',
      documentCpfPlaceholder: '000.000.000-00',
      documentCnpjPlaceholder: '00.000.000/0000-00',
      documentCpfHint: 'Digite 11 dígitos para CPF',
      documentCnpjHint: 'Digite 14 dígitos para CNPJ',
      documentCpfValid: 'CPF válido',
      documentCnpjValid: 'CNPJ válido',
      documentCpfTitle: 'CPF - Cadastro de Pessoa Física',
      documentCnpjTitle: 'CNPJ - Cadastro Nacional de Pessoa Jurídica',
      documentTypeHint: 'Escolha o tipo de documento antes de informar o número.',
      duplicateFoundTitle: 'Cliente já cadastrado',
      duplicateFoundMessage: 'Já existe um cadastro para este cliente.',
      goToEdit: 'Ir para Edição',
      checkingPhone: 'Verificando telefone...',
      checkingDocument: 'Verificando documento...',
      documentDuplicateCPF: 'Este CPF já está cadastrado para o cliente: {{name}}',
      documentDuplicateCNPJ: 'Este CNPJ já está cadastrado para o cliente: {{name}}',
      // Campos do formulário
      fullName: 'Nome Completo',
      fullNamePlaceholder: 'Digite o nome completo',
      documentLabel: 'Documento',
      cnhLabel: 'CNH',
      phonesLabel: 'Telefones',
      emailsLabel: 'E-mails',
      initialMessageLabel: 'Mensagem Inicial',
      messageLabel: 'Mensagem',
      messagePlaceholder: 'Digite a mensagem inicial do cliente...',
      personalInfoTitle: 'Informações Pessoais',
      personalInfoDescription: 'Identificação e dados principais do lead.',
      contactsTitle: 'Contatos',
      contactsDescription: 'Telefone e e-mail para manter o acompanhamento do lead.',
      vehicleInterestTitle: 'Busca de Veículo',
      vehicleInterestDescription: 'Interesses do lead para direcionar o atendimento.',
      messageDescription: 'Contexto inicial do atendimento enviado pelo cliente.',
      exit: 'Sair',
      openExisting: 'Abrir Cliente',
    },
    filters: {
      title: 'Filtros',
      search: 'Buscar',
      searchPlaceholder: 'Nome, telefone, email...',
      name: 'Nome',
      namePlaceholder: 'Filtrar por nome',
      phone: 'Telefone',
      phonePlaceholder: 'Filtrar por telefone',
      email: 'E-mail',
      emailPlaceholder: 'Filtrar por e-mail',
      document: 'Documento',
      documentPlaceholder: 'CPF/CNPJ',
      status: 'Status',
      source: 'Origem',
      serviceUser: 'Usuário de atendimento',
      serviceUserPlaceholder: 'Selecione usuário',
      vehicleInterest: 'Veículo de interesse',
      vehicleInterestPlaceholder: 'Buscar veículo...',
      hasProposal: 'Possui proposta',
      hasPreferences: 'Preferências preenchidas',
      funnelStage: 'Estágio do funil',
      converted: 'Convertido',
      createdAtFrom: 'Data criação (de)',
      createdAtTo: 'Data criação (até)',
      all: 'Todos',
      yes: 'Sim',
      no: 'Não',
      clearFilters: 'Limpar filtros',
      applyFilters: 'Filtrar',
      clear: 'Limpar',
      customerData: 'Dados do Cliente',
      createdAt: 'Data de Criação',
      proposalConversion: 'Proposta e Conversão',
    },
contactActions: {
      contact: 'Entrar em contato',
      duplicatePrompt: 'Ja possui um cadastro para esse cliente, deseja atualizar os dados?',
      duplicateRedirect: 'Redirecionando para atualizacao do cadastro existente.',
      duplicateCancelled: 'Cadastro nao criado devido a duplicidade.',
      duplicateFoundTitle: 'Cliente ja cadastrado',
      duplicateFoundMessage: 'Ja existe um cadastro para este cliente.',
      exit: 'Sair',
      openClient: 'Abrir Cliente',
    },
    status: {
      new: 'Novo',
      contacted: 'Contatado',
      qualified: 'Qualificado',
      proposal: 'Proposta',
      negotiating: 'Negociando',
      negotiation: 'Negociando',
      converted: 'Convertido',
      won: 'Ganho',
      lost: 'Perdido',
    },
    kanban: {
      funnelNotConfiguredTitle: 'Funil de vendas não configurado',
      funnelNotConfiguredDescription:
        'Para visualizar os leads em modo Kanban, você precisa configurar um funil de vendas. Acesse as configurações de leads para criar seu funil.',
      configureFunnelLink: 'Configurar funil de vendas',
      advanceRequiresAssignee:
        'Associe um vendedor ao lead antes de avançar para a próxima etapa.',
      moveToPreviousStage: 'Mover para etapa anterior',
      moveToNextStage: 'Mover para próxima etapa',
      nextStageRequiresAssignee: 'Associe um vendedor ao lead para avançar',
      stageUpdated: 'Etapa atualizada.',
      stageUpdateFailed: 'Não foi possível atualizar a etapa.',
    },
    drawer: {
      openWhatsAppConversations: 'Ir para conversas WhatsApp',
      assignSalesperson: 'Corretor responsável',
      assignSalespersonPlaceholder: 'Buscar corretor…',
      saveAssignee: 'Salvar corretor',
      assigneeUpdated: 'Corretor atualizado.',
      assigneeUpdateFailed: 'Não foi possível atualizar o corretor.',
      savingAssignee: 'Salvando…',
    },
    report: {
      title: 'Relatório de leads',
      subtitle:
        'Visualização tabular com os mesmos filtros da lista. Exporte CSV com todos os campos do cadastro.',
      exportCsv: 'Exportar CSV',
      exporting: 'Gerando arquivo…',
      exportSuccess: 'Download iniciado.',
      exportError: 'Não foi possível exportar o relatório.',
      exportHint: 'O CSV inclui endereço, preferências, financiamento, veículos de interesse e mais.',
      showingCount: 'Mostrando {{count}} de {{total}} leads (prévia até 500 linhas).',
      column: {
        name: 'Nome',
        document: 'Documento',
        status: 'Status',
        source: 'Origem',
        phone: 'Telefone',
        email: 'E-mail',
        assigned: 'Responsável',
        stage: 'Etapa',
        createdAt: 'Criado em',
      },
      filters: {
        dateFrom: 'Data de',
        dateTo: 'Data até',
        media: 'Mídia',
        allMedia: 'Todas mídias',
        stage: 'Etapa',
        allStages: 'Todas etapas',
        status: 'Status',
        allStatuses: 'Todos status',
        phone: 'Telefone',
        phonePlaceholder: 'Digite telefone',
        email: 'E-mail',
        emailPlaceholder: 'Digite e-mail',
        clear: 'Limpar filtros',
      },
    },
  },

  leadsSettingsHub: {
    title: 'Configurações de Leads',
    subtitle: 'Centralize as configurações de entrada, funil e distribuição de leads.',
    comingSoon: 'Em breve',
    cards: {
      kanban: {
        title: 'Kanban',
        description: 'Configure as etapas e regras do funil de leads.',
      },
      omnichannel: {
        title: 'Omnichannel',
        description: 'Central de atendimento e unificação de canais.',
      },
      integrations: {
        title: 'Integrações',
        description: 'Conecte canais e plataformas de captação de leads.',
      },
      webhooks: {
        title: 'Webhooks',
        description: 'Configure endpoints e payloads para entrada de leads.',
      },
      whatsapp: {
        title: 'WhatsApp',
        description: 'Configure a integração com WhatsApp Business API.',
      },
      distribution: {
        title: 'Distribuição',
        description: 'Gerencie regras de distribuição automática de leads.',
      },
    },
    integrations: {
      title: 'Integrações de Leads',
      subtitle: 'Configure integrações com plataformas e canais de aquisição de leads.',
      placeholder: 'Esta área será habilitada em uma próxima entrega.',
    },
    webhooks: {
      title: 'Webhooks de Leads',
      subtitle: 'Configure webhooks e use o endpoint público para receber leads.',
      publicEndpointTitle: 'Endpoint público para entrada de leads',
      payloadExampleTitle: 'Ver exemplo de payload JSON',
      curlExampleTitle: 'Ver exemplo de cURL',
      payloadHint: 'Payload esperado: name, phones [{ ddi, ddd, phone }], opcionalmente email, message e vehicleReference.',
      newTitle: 'Novo webhook',
      editTitle: 'Editar webhook',
      listTitle: 'Webhooks configurados',
      create: 'Criar webhook',
      saveEdit: 'Salvar alterações',
      empty: 'Nenhum webhook cadastrado.',
      saved: 'Webhook salvo com sucesso.',
      removed: 'Webhook removido com sucesso.',
      fields: {
        name: 'Nome',
        media: 'Mídia',
        mediaPlaceholder: 'Selecione...',
        active: 'Ativo',
      },
      errors: {
        required: 'Preencha nome e mídia.',
        save: 'Não foi possível salvar o webhook.',
        delete: 'Não foi possível remover o webhook.',
      },
    },
  },

  leadMediaSettings: {
    title: 'Catálogo de Mídias de Leads',
    subtitle: 'Cadastre mídias personalizadas e consulte o catálogo global servido pela API.',
    createTitle: 'Nova mídia da concessionária',
    sections: {
      catalogGlobal: 'Catálogo global',
      custom: 'Mídias da concessionária',
    },
    tier: {
      spotlight: 'Destaque',
      standard: 'Padrão',
    },
    fields: {
      key: 'Chave técnica',
      label: 'Nome exibido',
      color: 'Cor (hex)',
      sortOrder: 'Ordem',
      active: 'Ativa',
    },
    actions: {
      create: 'Criar mídia',
      clear: 'Limpar',
    },
    success: {
      saved: 'Mídia salva com sucesso.',
      deleted: 'Mídia removida com sucesso.',
    },
    errors: {
      load: 'Não foi possível carregar as mídias.',
      required: 'Preencha chave e nome da mídia.',
      save: 'Não foi possível salvar a mídia.',
      delete: 'Não foi possível remover a mídia. Verifique se ela está em uso.',
    },
    emptyCatalog: 'Nenhuma entrada no catálogo global.',
    emptyCustom: 'Nenhuma mídia customizada cadastrada.',
    readOnly: 'Somente leitura',
    active: 'ativa',
    inactive: 'inativa',
    meta: 'chave: {{key}} | ordem: {{order}} | {{status}}',
    metaCatalog: 'chave: {{key}} | ordem: {{order}} | {{tier}}',
  },

  leadWorkingMedia: {
    title: 'Mídias que a concessionária trabalha',
    subtitle: 'Selecione as mídias do catálogo global que a concessionária utiliza na operação.',
    catalogTitle: 'Catálogo de mídias',
    empty: 'Nenhuma mídia disponível.',
    active: 'Ativa',
    inactive: 'Inativa',
    rowAria: '{{label}}. Estado: {{state}}. Toque para alternar.',
    meta: 'chave: {{key}} | {{tier}}',
    tier: {
      spotlight: 'Destaque',
      standard: 'Padrão',
    },
    success: {
      updated: 'Seleção atualizada com sucesso.',
    },
    errors: {
      load: 'Não foi possível carregar as mídias.',
      update: 'Não foi possível atualizar a seleção.',
      keepNotInformed: 'A opção "Não informada" deve permanecer selecionada.',
    },
  },

  // Proposals
  proposals: {
    title: 'Propostas',
    new: 'Nova Proposta',
    edit: 'Editar Proposta',
    details: 'Detalhes da Proposta',
    form: {
      vehicle: 'Veículo',
      searchVehicle: 'Buscar veículo por nome, marca ou modelo...',
      financialProposalTitle: 'Proposta financeira',
      invalidNegotiatedPrice: 'Valor inválido.',
      advertisedPrice: 'Valor anunciado',
      negotiatedVehicleValue: 'Valor do veículo negociado',
      applyVehicleAdvertisedPrice: 'Valor do veículo',
      selectVehicleForPrices:
        'Selecione um veículo na etapa anterior para ver o valor anunciado.',
      referenceSectionTitle: 'Referência de preço',
      negotiationSectionTitle: 'Negociação',
      financialIntro:
        'Defina preços, benefícios e encargos que compõem o valor para o cliente.',
      paymentsMustBePositive: 'Todos os pagamentos devem ter um valor maior que R$ 0,00.',
      paymentsMustCoverFinalPrice:
        'O total dos pagamentos deve cobrir o valor final da proposta. Ajuste os valores antes de avançar ou salvar.',
    },
    actions: {
      acceptProposal: 'Aceitar Proposta',
      rejectProposal: 'Recusar Proposta',
      dialogAcceptTitle: 'Aceitar Proposta',
      dialogRejectTitle: 'Recusar Proposta',
      dialogAcceptBody:
        'Tem certeza que deseja aceitar esta proposta? Será criada uma venda e o veículo será marcado como vendido.',
      dialogRejectBody:
        'Tem certeza que deseja recusar esta proposta? Esta ação não pode ser desfeita.',
      confirmAccept: 'Sim, Aceitar',
      confirmReject: 'Sim, Recusar',
      toastAccepted: 'Proposta aceita com sucesso!',
      toastRejected: 'Proposta recusada com sucesso!',
      toastAcceptError: 'Erro ao aceitar proposta. Tente novamente.',
      toastRejectError: 'Erro ao recusar proposta. Tente novamente.',
    },
  },

  customers: {
    edit: {
      title: 'Editar cliente',
      sectionContact: 'Contato',
      sectionAddress: 'Endereço',
      sectionNotes: 'Observações',
      name: 'Nome',
      documentCpf: 'CPF',
      documentCnpj: 'CNPJ',
      documentReadOnlyHint: 'Documento não pode ser alterado.',
      email: 'E-mail',
      phone: 'Telefone',
      notes: 'Observações',
      save: 'Salvar',
      loadError: 'Não foi possível carregar o cliente.',
      saveError: 'Não foi possível salvar.',
      saveSuccess: 'Cliente atualizado.',
      sectionFunnelOrigin: 'Histórico do funil (lead de origem)',
      originLeadName: 'Nome no lead',
      originLeadSource: 'Origem',
      originLeadStatus: 'Estágio',
      originLeadCreatedAt: 'Criado em',
      originLeadConvertedAt: 'Convertido em',
      originLeadMessage: 'Mensagem inicial',
      originLeadNotes: 'Notas do funil',
      openOriginLead: 'Abrir lead',
    },
    address: {
      zipCode: 'CEP',
      lookupZip: 'Buscar CEP',
      zipInvalid: 'Informe um CEP com 8 dígitos.',
      street: 'Logradouro',
      number: 'Número',
      complement: 'Complemento',
      neighborhood: 'Bairro',
      city: 'Cidade',
      state: 'UF',
      searchingZip: 'Buscando CEP...',
      zipLookupError: 'Não foi possível buscar o CEP.',
    },
  },

  // Financial
  financial: {
    title: 'Financeiro',
    commissionRules: 'Regras de Comissão',
    newRule: 'Nova Regra',
    editRule: 'Editar Regra',
    basicConfig: 'Configuração Básica',
    advancedRules: 'Regras Avançadas',
    validity: 'Vigência',
    commissionType: 'Tipo de Comissão',
    percentage: 'Percentual',
    fixed: 'Valor Fixo',
    mixed: 'Misto',
    applicableTo: 'Aplicável a',
    salesperson: 'Vendedor',
    manager: 'Gerente',
    dealership: 'Loja',
    isMandatoryCommission: 'Comissão obrigatória na venda',
    isMandatoryCommissionHint:
      'Quando ativa, a regra é aplicada automaticamente na venda e os valores não podem ser alterados.',
    mandatoryRuleBadge: 'Obrigatória',
  },

  // Settings
  settings: {
    title: 'Configurações',
    theme: 'Tema',
    language: 'Idioma',
    notifications: 'Notificações',
    operationPipeline: {
      cardTitle: 'Esteira operacional',
      cardDescription: 'Colunas do kanban e modelos de checklist por etapa.',
      pageTitle: 'Esteira operacional',
      pageSubtitle: 'Defina colunas do kanban (preparação e pós-recebimento) e modelos de checklist.',
      tabKanban: 'Kanban',
      tabChecklists: 'Checklists',
      kanbanTitle: 'Colunas do quadro',
      boardStage: 'Etapa do quadro',
      active: 'Ativa',
      handoff: 'Coluna de liberação',
      columnResponsible: 'Responsável da coluna',
      columnResponsibleEmpty: 'Sem responsável',
      newColumnTitle: 'Nova coluna',
      newColumnPlaceholder: 'Ex.: Lavagem',
      addColumn: 'Adicionar coluna',
      kanbanLoadError: 'Não foi possível carregar as colunas.',
      columnCreated: 'Coluna criada.',
      columnSaveError: 'Não foi possível salvar a coluna.',
      columnDeleted: 'Coluna removida.',
      columnDeleteError: 'Não foi possível remover a coluna.',
      reorderOk: 'Ordem atualizada.',
      reorderError: 'Não foi possível reordenar.',
      confirmDeleteColumn: 'Excluir coluna?',
      confirmDeleteColumnHint:
        'Todos os veículos/clientes nesta coluna serão movidos automaticamente para a coluna anterior. Os itens de checklist vinculados a esta coluna serão removidos. Esta ação não pode ser desfeita.',
      edgeColumnBadge: 'Fixa',
      edgeColumnHelp: 'A primeira e a última coluna do quadro não podem ser editadas nem excluídas.',
      columnChecklistTitle: 'Checklist desta coluna',
      columnChecklistHelp:
        'Itens exibidos como checklist quando a venda está nesta coluna. Sincronizado com o modelo vinculado à coluna.',
      columnChecklistLines: 'Itens',
      columnChecklistPlaceholder: 'Ex.: Lavagem externa\nChecklist de acessórios',
      checklistItemPlaceholder: 'Texto do item',
      addChecklistItem: 'Adicionar item',
      removeChecklistItem: 'Remover item',
      templateItemsEmpty: 'Nenhum item neste modelo.',
      saveColumnChecklist: 'Salvar checklist da coluna',
      columnChecklistSaved: 'Checklist da coluna salvo.',
      columnChecklistError: 'Não foi possível salvar o checklist da coluna.',
      checklistsTitle: 'Modelos de checklist',
      filterStage: 'Filtrar por etapa',
      allStages: 'Todas as etapas',
      items: 'itens',
      noTemplates: 'Nenhum modelo cadastrado.',
      newTemplate: 'Novo modelo',
      templateStage: 'Etapa operacional',
      itemsLines: 'Itens (um por linha)',
      itemsPlaceholder: 'Documentação\nVistoria final\nTreinamento do cliente',
      createTemplate: 'Criar modelo',
      templateFormInvalid: 'Informe o nome e ao menos um item.',
      templateCreated: 'Modelo criado.',
      templateSaveError: 'Não foi possível salvar o modelo.',
      templateDeleted: 'Modelo removido.',
      templateDeleteError: 'Não foi possível excluir o modelo.',
      checklistLoadError: 'Não foi possível carregar os modelos.',
      confirmDeleteTemplate: 'Excluir modelo?',
      confirmDeleteTemplateHint: 'Novas vendas deixarão de receber este modelo automaticamente. Itens já criados em vendas não são removidos.',
      tabSaleOnboarding: 'Pré-esteira venda',
      saleOnboardingIntro:
        'Defina documentos exigidos e modelos de contrato antes de enviar a venda da área financeira para a preparação operacional.',
      onboardingLoadError: 'Não foi possível carregar a configuração de pré-esteira.',
      onboardingDocTypesTitle: 'Tipos de documento',
      onboardingContractTemplatesTitle: 'Modelos de contrato',
      onboardingSlug: 'Slug',
      onboardingAttach: 'Onde o arquivo será anexado',
      onboardingAttachSale: 'Na venda',
      onboardingAttachCustomer: 'No cadastro do cliente',
      onboardingSort: 'Ordem de exibição',
      onboardingRequired: 'Obrigatório',
      onboardingDocTypesEmpty:
        'Nenhum tipo cadastrado. Sem tipos ativos obrigatórios, a etapa de documentação é considerada concluída.',
      onboardingContractsEmpty: 'Nenhum modelo cadastrado.',
      onboardingNewDocType: 'Novo tipo de documento',
      onboardingAddDocType: 'Adicionar tipo',
      onboardingDocTypeInvalid: 'Informe nome e slug.',
      onboardingDocTypeCreated: 'Tipo criado.',
      onboardingDocTypeCreateError: 'Não foi possível criar o tipo.',
      onboardingDocTypeSaved: 'Tipo atualizado.',
      onboardingDocTypeSaveError: 'Não foi possível atualizar o tipo.',
      onboardingDocTypeDeleted: 'Tipo removido.',
      onboardingDocTypeDeleteError: 'Não foi possível remover o tipo.',
      onboardingNewContract: 'Novo modelo de contrato',
      onboardingAddContract: 'Adicionar modelo',
      onboardingRefUrlPlaceholder: 'URL de referência do modelo (opcional)',
      onboardingContractRefUpload: 'Enviar arquivo',
      onboardingContractRefUploading: 'Enviando…',
      onboardingContractRefUploadError: 'Não foi possível enviar o arquivo.',
      onboardingContractRefOpen: 'Abrir',
      onboardingContractRefPending: 'Arquivo no servidor — será vinculado ao criar o modelo.',
      onboardingContractInvalid: 'Informe o nome do modelo.',
      onboardingContractCreated: 'Modelo criado.',
      onboardingContractCreateError: 'Não foi possível criar o modelo.',
      onboardingContractSaved: 'Modelo atualizado.',
      onboardingContractSaveError: 'Não foi possível atualizar o modelo.',
      onboardingContractDeleted: 'Modelo removido.',
      onboardingContractDeleteError: 'Não foi possível remover o modelo.',
      confirmDeleteOnboardingDocType: 'Excluir tipo de documento?',
      confirmDeleteOnboardingDocTypeHint:
        'Só é possível excluir se não houver cumprimentos de venda vinculados a este tipo.',
      confirmDeleteOnboardingContract: 'Excluir modelo de contrato?',
      confirmDeleteOnboardingContractHint:
        'Só é possível excluir se não houver cumprimentos de venda vinculados a este modelo.',
    },
    paymentForms: {
      isFinancing: 'Financiamento',
      isCashPayment: 'À vista',
      kindHint: 'Classifique a forma para relatórios e regras. Apenas uma das opções pode ficar ativa.',
      exclusiveConflict: 'Não é possível marcar financiamento e à vista ao mesmo tempo.',
      badgeFinancing: 'Financiamento',
      badgeCash: 'À vista',
    },
    dealership: {
      pageTitle: 'Configurações da Concessionária',
      pageSubtitle: 'Filiais, dados fiscais por filial e categorias de veículo',
      vehicleTypes: {
        title: 'Tipos de Veículos',
        sectionTitle: 'Tipos de Veículos Aceitos',
        sectionDescription: 'Selecione os tipos de veículos que sua concessionária trabalha. Se nenhum tipo for selecionado, todos serão exibidos.',
        saveButton: 'Salvar Tipos de Veículos',
        saveSuccess: 'Salvo com sucesso',
      },
      branch: {
        title: 'Filiais',
        sectionTitle: 'Filiais',
        newButton: 'Nova Filial',
        emptyTitle: 'Nenhuma filial cadastrada',
        emptyDescription: 'Clique em "Nova Filial" para adicionar a primeira filial.',
        primaryBadge: 'Matriz',
        listVehicleCategories: 'Categorias',
        categoryLabels: {
          A: 'Motocicletas',
          B: 'Automóveis',
          C: 'Caminhões',
          D: 'Ônibus',
        },
        form: {
          newTitle: 'Nova Filial',
          editTitle: 'Editar Filial',
          createButton: 'Criar Filial',
          saveEditButton: 'Salvar Alterações',
          saveError: 'Erro ao salvar filial',
          sectionBranch: 'Identificação',
          sectionContact: 'Contato',
          sectionAddress: 'Endereço',
          sectionFiscal: 'Fiscal (NF-e / exportação)',
          fiscalHint:
            'IE, regime tributário e padrões NCM/CFOP desta filial. Na venda, o veículo deve estar vinculado a esta filial para usar estes dados no emitente.',
          phoneHint: 'Opcional. DDD + número (fixo ou celular).',
          categoriesSection: 'Categorias de veículo nesta filial',
          categoriesHint: 'Defina quais tipos de veículo podem ser cadastrados nesta filial. É obrigatório manter ao menos uma categoria.',
          categoriesRequired: 'Selecione pelo menos uma categoria de veículo.',
          invalidEmail: 'Digite um e-mail válido.',
          invalidPhone: 'Informe um telefone válido com DDD (10 ou 11 dígitos após o DDD).',
          zipCodeLookupError: 'Não foi possível buscar o CEP informado.',
          zipCodeIncomplete: 'Informe o CEP com 8 dígitos antes de buscar.',
          zipSearchButton: 'Buscar CEP',
          zipSearchHint: 'Digite o CEP e clique em Buscar CEP, ou pressione Enter no campo.',
          searchingZipCode: 'Buscando endereço pelo CEP...',
          requiredFieldError: 'Campo obrigatório não preenchido: {{field}}',
          fields: {
            name: 'Nome da filial *',
            phone: 'Telefone',
            email: 'E-mail',
            zipCode: 'CEP *',
            street: 'Logradouro *',
            number: 'Número *',
            complement: 'Complemento',
            neighborhood: 'Bairro *',
            city: 'Cidade *',
            state: 'UF *',
            stateRegistration: 'Inscrição estadual (IE)',
            taxRegime: 'Regime tributário',
            fiscalDefaultNcm: 'NCM padrão',
            fiscalDefaultCfop: 'CFOP padrão',
          },
          placeholders: {
            name: 'Ex: Matriz São Paulo',
            email: 'filial@empresa.com',
            street: 'Rua, avenida…',
            number: 'Nº',
            complement: 'Sala, bloco…',
            neighborhood: 'Bairro',
            city: 'Cidade',
          },
        },
      },
      registration: {
        title: 'Cadastro de empresa',
        subtitle: 'Preencha os dados da sua empresa para criar a conta administrativa',
        stepTitles: {
          company: 'Dados da empresa',
          user: 'Usuário administrador',
          payment: 'Confirmação do plano',
        },
        stepDescriptions: {
          company: 'Informe o CNPJ e os dados cadastrais da empresa',
          user: 'Crie o usuário responsável pelo acesso',
          payment: 'Revise as informações antes de concluir',
        },
        company: {
          document: 'Documento da empresa',
          cpf: 'CPF',
          cnpj: 'CNPJ',
          cnpjPlaceholder: '00.000.000/0000-00',
          cnpjHint: 'Use o CNPJ da empresa que será cadastrada.',
          legalName: 'Razão social',
          legalNamePlaceholder: 'Razão social da empresa',
          tradeName: 'Nome fantasia',
          tradeNamePlaceholder: 'Nome fantasia da empresa',
          cpfName: 'Nome do responsável',
          cpfNamePlaceholder: 'Nome completo',
          email: 'E-mail da empresa',
          emailPlaceholder: 'contato@empresa.com',
          phone: 'Telefone da empresa',
          phonePlaceholder: '(11) 99999-9999',
          address: 'Endereço da empresa',
        },
        user: {
          sectionTitle: 'Acesso administrativo',
          sectionSubtitle: 'Defina os dados do responsável pela conta da empresa.',
          name: 'Nome do responsável',
          namePlaceholder: 'Nome completo',
          email: 'E-mail do responsável',
          emailPlaceholder: 'admin@empresa.com',
          password: 'Senha do administrador',
          passwordPlaceholder: 'Mínimo 6 caracteres',
          confirmPassword: 'Confirmar senha',
          confirmPasswordPlaceholder: 'Confirme sua senha',
        },
        payment: {
          selectedPlan: 'Plano selecionado',
          vehiclesUnlimited: 'Veículos ilimitados',
          vehicles: '{{count}} veículos',
          free: 'Gratuito',
          perMonth: '/mês',
          companySummary: 'Resumo da empresa',
          termsTitle: 'Termos e condições',
          termsPrefix: 'Ao continuar, você concorda com nossos',
          termsLink: 'Termos de Uso',
          and: 'e',
          privacyLink: 'Política de Privacidade',
        },
        actions: {
          back: 'Voltar',
          continue: 'Continuar',
          validating: 'Validando...',
          finish: 'Finalizar cadastro',
        },
        login: {
          prompt: 'Já tem uma conta?',
          link: 'Faça login',
        },
        success: {
          noTokenMessage: 'Empresa cadastrada com sucesso! Faça login para continuar.',
          verificationRequired: 'Empresa cadastrada com sucesso! Verifique seu e-mail para continuar.',
        },
        validation: {
          cpfRequired: 'CPF é obrigatório',
          cpfLength: 'Digite 11 dígitos para CPF',
          cpfValidating: 'Validando CPF...',
          cpfInvalid: 'CPF inválido',
          cpfValidationError: 'Erro ao validar CPF. Tente novamente.',
          cnpjRequired: 'CNPJ é obrigatório',
          cnpjLength: 'Digite 14 dígitos para CNPJ',
          cnpjValidating: 'Validando CNPJ...',
          cnpjInvalid: 'CNPJ inválido',
          cnpjValidationError: 'Erro ao validar CNPJ. Tente novamente.',
          tooManyRequests: 'Muitas tentativas. Aguarde um momento e tente novamente.',
          legalNameRequired: 'Razão social é obrigatória',
          companyEmailRequired: 'E-mail da empresa é obrigatório',
          invalidEmail: 'E-mail inválido',
          phoneRequired: 'Telefone é obrigatório',
          invalidPhone: 'Telefone inválido',
          addressRequired: 'Preencha o endereço completo (CEP, rua, número, bairro, cidade e UF).',
          userNameRequired: 'Nome é obrigatório',
          userEmailRequired: 'E-mail é obrigatório',
          passwordRequired: 'Senha é obrigatória',
          passwordLength: 'Senha deve ter pelo menos 6 caracteres',
          confirmPasswordRequired: 'Confirmação de senha é obrigatória',
          passwordMismatch: 'Senhas não coincidem',
          submitError: 'Erro ao cadastrar empresa. Tente novamente.',
          connectionError: 'Erro de conexão. Verifique sua internet e tente novamente.',
          cpfNameRequired: 'Nome é obrigatório',
          fieldRequired: 'Obrigatório',
        },
        hero: {
          eyebrow: 'Registro premium',
          title: 'Uma experiência de cadastro com cara de produto sério',
          subtitle:
            'Fluxo guiado em 3 passos, com resumo lateral fixo e leitura visual muito mais forte para o público da concessionária.',
          stats: {
            validationTitle: 'Validação',
            validationValue: 'Em tempo real',
            validationDescription: 'CNPJ, CEP e campos críticos com feedback imediato.',
            flowTitle: 'Fluxo',
            flowValue: '3 etapas',
            flowDescription: 'Empresa, usuário e confirmação do plano sem ruído.',
            securityTitle: 'Confiança',
            securityValue: 'Conta pronta',
            securityDescription: 'Resumo claro antes do envio final.',
          },
          bullets: {
            premiumVisualTitle: 'Visual premium',
            premiumVisualDescription: 'Mais hierarquia, contraste e presença de marca.',
            guidedFlowTitle: 'Fluxo guiado',
            guidedFlowDescription: 'O usuário entende o próximo passo sem esforço.',
            trustTitle: 'Mais confiança',
            trustDescription: 'Resumo, progresso e revisão reduzem abandono.',
          },
        },
        sidebar: {
          eyebrow: 'Resumo da adesão',
          quickSummary: 'Resumo rápido',
          title: 'Tudo que você precisa para concluir',
          planActive: 'Plano ativo',
          progressLabel: 'Progresso do cadastro',
          progressValue: '{{current}} de {{total}} etapas',
          planSummary: 'Plano selecionado',
          planUsers: 'Usuários incluídos',
          planVehicles: 'Veículos incluídos',
          usersCount: '{{count}} usuários',
          usersUnlimited: 'Usuários ilimitados',
          stepPrefix: 'Etapa {{count}}',
          benefits: {
            title: 'Destaques do onboarding',
            fastSetupTitle: 'Entrada mais rápida',
            fastSetupDescription: 'A estrutura visual conduz o cadastro com menos atrito.',
            protectedAccessTitle: 'Acesso protegido',
            protectedAccessDescription: 'Credenciais e resumo final apresentados com clareza.',
            accountReadyTitle: 'Conta pronta para operar',
            accountReadyDescription: 'Ao concluir, a estrutura inicial já fica definida.',
          },
        },
        form: {
          eyebrow: 'Cadastro da concessionária',
        },
        common: {
          notProvided: 'Não informado',
        },
      },
    },
  },
  // WhatsApp
  whatsapp: {
    title: 'WhatsApp Business',
    subtitle: 'Configure a integração com WhatsApp Business API para enviar e receber mensagens',
    newTitle: 'Nova Configuração',
    editTitle: 'Editar Configuração',
    confirmDelete: 'Tem certeza que deseja remover a configuração do WhatsApp?',
    noMessages: 'Nenhuma mensagem ainda',
    typeMessage: 'Digite uma mensagem...',
    downloadMedia: 'Baixar arquivo',
    emojiPicker: 'Emojis',
    suggestionTitle: 'Sugestões para aplicar no lead',
    suggestionApplying: 'Aplicando...',
    suggestionApplied: 'Interesse aplicado no lead',
    suggestionDismiss: 'Descartar sugestão e não mostrar de novo',
    suggestionPurchaseIntent: 'Aplicar intenção de compra',
    suggestionUsageType: 'Aplicar tipo de uso',
    suggestionVehicleMoment: 'Aplicar momento do veículo',
    suggestionFinancing: 'Aplicar interesse em financiamento',
    suggestionTradeIn: 'Aplicar interesse em troca',
    suggestionNotePurchaseIntent: 'Intenção de compra detectada na conversa.',
    suggestionNoteUsageType: 'Tipo de uso detectado na conversa.',
    suggestionNoteVehicleMoment: 'Momento de troca/compra detectado na conversa.',
    suggestionNoteTradeIn: 'Interesse em troca/permuta detectado na conversa.',
    suggestionNoteFinancing: 'Interesse em financiamento detectado na conversa.',
    suggestionKeywords: {
      wantsFinancing: 'financiar|financiamento|financiado|financeiro|financial|financing|parcela|entrada',
      hasTradeIn: 'troca|permuta|dar de entrada|veiculo na troca|trade in',
      purchaseIntentUrgent: 'urgente|essa semana|hoje|o quanto antes|fechar hoje',
      purchaseIntentResearching: 'pesquisando|olhando|analisando|estou vendo',
      purchaseIntentComparing: 'comparando|comparar|outras opcoes|outras opções',
      usageTypeUber: 'uber|99|app de corrida',
      usageTypeCommercial: 'trabalho|comercial|empresa|frota',
      usageTypeFamily: 'familia|família|filhos',
      usageTypePersonal: 'pessoal|uso proprio|uso próprio',
      vehicleMomentFirstCar: 'primeiro carro|primeiro veiculo|primeiro veículo',
      vehicleMomentUpgrade: 'upgrade|trocar por melhor|subir de categoria',
      vehicleMomentReplacement: 'substituir|substituicao|substituição|trocar o atual',
    },
    retryAction: 'Reenviar mensagem',
    retryLabel: 'Reenviar',
    retrySent: 'Mensagem reenviada com sucesso',
    retryMediaUnavailable: 'Nao foi possivel reenviar: midia indisponivel',

    status: {
      active: 'Ativo',
      inactive: 'Inativo',
    },

    fields: {
      phoneNumberId: 'Phone Number ID',
      businessAccountId: 'Business Account ID',
      accessToken: 'Access Token',
      webhookVerifyToken: 'Webhook Verify Token',
      isActive: 'Ativo',
      autoReply: 'Resposta automática',
      autoCreateLead: 'Criar lead automaticamente',
    },

    placeholders: {
      phoneNumberId: 'ID do número de telefone',
      businessAccountId: 'ID da conta business',
      accessToken: 'Token de acesso de longa duração',
      webhookVerifyToken: 'Token de verificação do webhook',
    },

    actions: {
      test: 'Testar Conexão',
      syncTemplates: 'Sincronizar Templates',
      connectWithMeta: 'Conectar com Meta',
    },

    messageTypes: {
      text: 'Texto',
      image: 'Imagem',
      video: 'Vídeo',
      document: 'Documento',
      template: 'Template',
    },

    templates: {
      title: 'Templates de Mensagem',
      subtitle: 'Gerencie templates aprovados do WhatsApp Business',
      empty: 'Nenhum template configurado',
      emptyHint: 'Sincronize os templates do WhatsApp Business ou crie novos no Meta Business Manager',
      used: 'Usado',
      times: 'vezes',
      helpTitle: 'Como usar templates',
      help1: 'Templates são mensagens pré-aprovadas pelo WhatsApp para iniciar conversas.',
      help2: 'Crie e aprove templates no Meta Business Manager antes de usá-los aqui.',
      help3: 'Use o botão "Sincronizar Templates" para importar templates aprovados.',
      sync: 'Sincronizar Templates',
      usageCount: 'Uso',
      syncHint: 'Clique em "Sincronizar Templates" para carregar templates da Meta',
    },

    templateStatus: {
      approved: 'Aprovado',
      pending: 'Pendente',
      rejected: 'Rejeitado',
      inactive: 'Inativo',
    },

    templateCategory: {
      marketing: 'Marketing',
      utility: 'Utilidade',
      authentication: 'Autenticação',
    },

    success: {
      created: 'Configuração do WhatsApp criada com sucesso!',
      updated: 'Configuração atualizada com sucesso!',
      deleted: 'Configuração removida com sucesso!',
      tested: 'Conexão testada com sucesso!',
      messageSent: 'Mensagem enviada com sucesso!',
      templatesSynced: 'Templates sincronizados com sucesso!',
      oauthConnected: 'Conectado com sucesso via Meta!',
      connected: 'WhatsApp conectado com sucesso!',
      disconnected: 'WhatsApp desconectado com sucesso',
    },

    errors: {
      load: 'Não foi possível carregar a configuração.',
      required: 'Todos os campos são obrigatórios.',
      save: 'Não foi possível salvar a configuração.',
      delete: 'Não foi possível remover a configuração.',
      test: 'Erro ao testar a conexão.',
      testFailed: 'Teste de conexão falhou',
      loadMessages: 'Não foi possível carregar as mensagens.',
      sendMessage: 'Não foi possível enviar a mensagem.',
      loadTemplates: 'Não foi possível carregar os templates.',
      syncTemplates: 'Não foi possível sincronizar os templates.',
      oauthFailed: 'Erro ao conectar com Meta. Tente novamente.',
      reconnect: 'Erro ao reconectar',
      disconnect: 'Erro ao desconectar WhatsApp',
    },

    errorTypes: {
      META_AUTHENTICATION: 'Erro de autenticação',
      META_RATE_LIMIT: 'Limite excedido',
      META_BUSINESS_RULE: 'Regra de negócio',
      META_VALIDATION: 'Validação',
      META_COUNTRY_RESTRICTION: 'Restrição de país',
      META_NUMBER_NOT_ALLOWED: 'Número não permitido',
      META_TEMPLATE_NOT_APPROVED: 'Template não aprovado',
      SYSTEM_ERROR: 'Erro do sistema',
      INVALID_CONFIG: 'Configuração inválida',
      WHATSAPP_CHANNEL_SESSION_EXPIRED: 'Fora da janela de 24 horas; use um template aprovado',
      WHATSAPP_CONVERSATION_FINALIZED: 'Conversa encerrada; reabra ou aguarde o cliente',
      META_PHONE_NUMBER_UNAVAILABLE:
        'Phone Number ID ou token inválidos para a Meta — atualize a configuração ou reconecte o WhatsApp',
    },

    session: {
      templateOnlyBanner:
        'Só é possível enviar templates aprovados. A janela de 24h após a última mensagem do cliente expirou.',
      closedBanner: 'Conversa encerrada. Reabra para voltar a contar no tempo de resposta ou use template.',
      finalize: 'Encerrar conversa',
      reopen: 'Reabrir conversa',
      finalizedToast: 'Conversa encerrada.',
      reopenedToast: 'Conversa reaberta.',
    },

    errorHelp: {
      metaIssue: 'Este é um problema de configuração no Meta Business Manager, não no sistema.',
      checkMeta: 'Verifique as configurações no Meta Business Manager',
      openMetaManager: 'Abrir Meta Business Manager',
    },

    info: {
      dialogTitle: 'Detalhes da Integração WhatsApp',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      activeStatus: 'WhatsApp está ativo e funcionando',
      inactiveStatus: 'WhatsApp está inativo',
      noConfig: 'Nenhuma configuração encontrada',
      noConfigHint: 'Clique em "Conectar" na página de Marketplace para configurar o WhatsApp.',
      lastSync: 'Última Sincronização',
      createdAt: 'Criado em',
      never: 'Nunca',
      configurations: 'Configurações',
      autoReplyEnabled: 'Auto-resposta ativada',
      autoCreateLeadEnabled: 'Criação automática de leads',
      lastError: 'Último erro',
      webhookUrl: 'Webhook URL',
      webhookHint: 'Configure esta URL no Meta Dashboard:',
      reconnect: 'Reconectar',
      reconnecting: 'Reconectando...',
      disconnect: 'Desconectar',
      disconnecting: 'Desconectando...',
      close: 'Fechar',
      confirmDisconnect: 'Tem certeza que deseja desconectar o WhatsApp?',
      confirmDisconnectWarning: 'Todos os dados de configuração serão removidos e você precisará reconectar novamente.',
      confirmDisconnectButton: 'Sim, Desconectar',
      processingConnection: 'Processando conexão...',
    },

    help: {
      step1Title: '1. Criar App no Meta Business',
      step1: 'Acesse developers.facebook.com e crie um app Business. Ative a API do WhatsApp Business.',
      step2Title: '2. Obter Credenciais',
      step2: 'No painel do app, acesse "WhatsApp > API Setup" para obter Phone Number ID e Access Token permanente.',
      step3Title: '3. Configurar Webhook',
step3: 'Configure o webhook do WhatsApp para receber mensagens. Use a URL e token abaixo.',
      webhookTitle: 'URL do Webhook',
      webhookUrl: 'URL',
    },

    inbox: {
      title: 'Caixa de Entrada WhatsApp',
      subtitle: 'Gerencie conversas e responda mensagens dos seus leads',
      conversations: 'Conversas',
      searchPlaceholder: 'Buscar por nome ou número...',
      empty: 'Nenhuma conversa ainda',
      noResults: 'Nenhum resultado encontrado',
      noMessages: 'Sem mensagens',
      selectConversation: 'Selecione uma conversa',
      selectConversationHint: 'Escolha uma conversa na lista à esquerda para começar',
      now: 'agora',
      filters: {
        all: 'Todas',
        unread: 'Não lidas',
        today: 'Hoje',
        mine: 'Minhas',
      },
      rightPanel: {
        empty: 'Selecione uma conversa para ver dados e estoque.',
        leadSection: 'Contato',
        noLead: 'Sem lead vinculado a esta conversa.',
        vehicleSearch: 'Buscar veículo',
        searchVehicles: 'Buscar',
        vehiclesFound: '{{count}} veículo(s) encontrado(s)',
        expandContactSection: 'Expandir contato',
        collapseContactSection: 'Recolher contato',
        expandFiltersSection: 'Expandir filtros',
        collapseFiltersSection: 'Recolher filtros',
        noVehicles: 'Nenhum veículo encontrado com os filtros.',
        sendVehicleInfo: 'Enviar resumo no WhatsApp',
        sendPhotos: 'Enviar fotos',
        sendDocuments: 'Enviar documentos',
        confirmSend: 'Enviar',
        confirmPhotosTitle: 'Enviar fotos pelo WhatsApp?',
        confirmPhotosBody:
          'Serão enviadas até 10 fotos do veículo em sequência. As URLs precisam estar acessíveis pela Meta.',
        confirmDocsTitle: 'Enviar documentos pelo WhatsApp?',
        confirmDocsBody: 'Os arquivos serão enviados um a um como documento.',
        success: {
          textSent: 'Resumo do veículo enviado.',
          photosSent: '{{count}} foto(s) enviada(s).',
          photosPartial: '{{ok}} de {{total}} foto(s) enviadas.',
          docsSent: '{{count}} documento(s) enviado(s).',
          docsPartial: '{{ok}} de {{total}} documento(s) enviados.',
        },
        errors: {
          loadLead: 'Não foi possível carregar o lead.',
          loadVehicles: 'Não foi possível carregar veículos.',
          sendFailed: 'Falha ao enviar pelo WhatsApp.',
          noPhotos: 'Este veículo não tem fotos disponíveis.',
          noDocuments: 'Este veículo não tem documentos disponíveis.',
        },
      },
      errors: {
        loadConversations: 'Não foi possível carregar as conversas.',
      },
    },
  },
  marketplace: {
    title: 'Marketplace',
    subtitle: 'Conecte suas integrações para atrair mais leads',
    comingSoon: 'Em breve',
    comingSoonHint:
      'Esta integração ainda não está disponível nesta versão. Por enquanto, use Mercado Livre e WhatsApp.',
    connected: 'Conectado',
    notConnected: 'Não conectado',
    howToConnect: 'Como conectar',
    connect: 'Conectar',
    connecting: 'Conectando...',
    disconnect: 'Desconectar',
    disconnecting: 'Desconectando...',
    reconnect: 'Reconectar',
    reconnecting: 'Reconectando...',
    viewDetails: 'Ver Detalhes',
    templates: 'Templates',
    integrations: {
      whatsapp: {
        name: 'WhatsApp Business',
        description: 'Conecte o WhatsApp Business para receber e enviar mensagens, criar leads automaticamente e gerenciar templates.',
        helpText: 'Necessário ter uma conta WhatsApp Business API aprovada pela Meta.',
      },
      meta: {
        name: 'Meta',
        description: 'Conecte seu Instagram e Facebook Business para receber leads automaticamente.',
        helpText: 'Necessita ter uma conta Business do Facebook e uma Página do Instagram profissional.',
      },
      mercadolivre: {
        name: 'Mercado Livre',
        description: 'Publique seus veículos automaticamente e receba mensagens dos compradores.',
        helpText: 'É necessário ter uma conta de vendedor no Mercado Livre e um aplicativo aprovado.',
        title: 'Mercado Livre',
        oauthConnected: 'Conta do Mercado Livre vinculada com sucesso.',
        notConfigured: 'Mercado Livre ainda não está configurado.',
        active: 'Integração ativa e funcionando.',
        accountInfo: 'Informações da conta',
        userId: 'ID do usuário',
        connectedAt: 'Conectado em',
        lastSync: 'Última sincronização',
        lastError: 'Último erro',
        disconnect: {
          title: 'Desconectar Mercado Livre',
          warning:
            'Ao desconectar, você não poderá publicar nem sincronizar anúncios até vincular a conta novamente.',
        },
        errors: {
          load: 'Não foi possível carregar o status do Mercado Livre.',
          reconnect: 'Não foi possível iniciar a reconexão.',
          disconnect: 'Não foi possível desconectar o Mercado Livre.',
          notFound: 'Nenhuma integração do Mercado Livre encontrada.',
        },
      },
      olx: {
        name: 'OLX',
        description: 'Divulgue seus veículos na maior plataforma de anúncios do Brasil.',
        helpText: 'Requer conta profissional OLX e aprovação do anúncio.',
      },
    },

    success: {
      connected: 'Integração conectada com sucesso!',
      disconnected: 'Integração desconectada com sucesso!',
    },

    errors: {
      connect: 'Erro ao conectar',
      unknown: 'Erro desconhecido',
    },

    publications: {
      title: 'Publicações',
      subtitle: 'Gerencie a publicação de veículos nos marketplaces',
      selectMarketplace: 'Selecione o marketplace',
      searchVehicles: 'Buscar veículos...',
      publish: 'Publicar',
      publishing: 'Publicando...',
      selectAtLeastOne: 'Selecione pelo menos um veículo',
      selectAll: 'Selecionar Todos',
      deselectAll: 'Desmarcar Todos',
      availableVehicles: 'Veículos Disponíveis',
      vehicle: 'Veículo',
      year: 'Ano',
      price: 'Preço',
      status: 'Status',
      publishedOn: 'Publicado Em',
      actions: 'Ações',
      history: 'Histórico',
      notPublished: 'Não publicado',
      success: '{{queued}} veículos enviados para publicação. {{failed}} falharam.',
      error: 'Erro ao publicar veículos',
      autoPublish: {
        title: 'Publicação Automática',
        enabled: 'Ativada',
        disabled: 'Desativada',
        enable: 'Ativar publicação automática',
        disable: 'Desativar publicação automática',
        description: 'Os veículos serão publicados automaticamente nos horários de carga do marketplace',
        scheduleInfo: 'Horários de Carga',
        scheduleDescription: 'Os marketplaces processam publicações em horários específicos para melhor desempenho',
        error: 'Erro ao atualizar a publicação automática',
      },
    },

    history: {
      title: 'Histórico de Publicações',
      subtitle: 'Acompanhe todas as publicações realizadas',
      filterByMarketplace: 'Filtrar por Marketplace',
      filterByStatus: 'Filtrar por Status',
      allMarketplaces: 'Todos os Marketplaces',
      allStatuses: 'Todos os Status',
      vehicle: 'Veículo',
      marketplace: 'Marketplace',
      status: 'Status',
      publishedAt: 'Publicado em',
      createdAt: 'Criado em',
      updatedAt: 'Atualizado em',
      actions: 'Ações',
      viewAd: 'Ver Anúncio',
      noPublications: 'Nenhuma publicação encontrada',
      error: 'Erro ao carregar histórico',
      page: 'Página',
      of: 'de',
      previous: 'Anterior',
      next: 'Próxima',
      statusTypes: {
        PENDING: 'Pendente',
        PUBLISHED: 'Publicado',
        FAILED: 'Falhou',
        UPDATING: 'Atualizando',
        PAUSED: 'Pausado',
        REMOVED: 'Removido',
      },
    },

    logs: {
      title: 'Histórico',
      loadingHistory: 'Carregando histórico...',
      noPublications: 'Nenhuma publicação encontrada para este veículo',
      viewAd: 'Ver Anúncio',
      eventHistory: 'Histórico de Eventos',
      noEvents: 'Nenhum evento registrado',
      attempt: 'Tentativa',
      hideDetails: 'Ocultar detalhes',
      showDetails: 'Ver detalhes',
      errorDetails: 'Detalhes do Erro:',
      apiResponse: 'Resposta da API:',
      error: 'Erro ao carregar histórico',
      actions: {
        CREATED: 'Criado',
        QUEUED: 'Na Fila',
        PROCESSING: 'Processando',
        PUBLISHED: 'Publicado',
        UPDATED: 'Atualizado',
        FAILED: 'Falhou',
        RETRYING: 'Tentando Novamente',
        REMOVED: 'Removido',
        ERROR: 'Erro',
      },
    },
  },

  // Conversations
  conversations: {
    title: 'Conversas',
    searchPlaceholder: 'Buscar conversas...',
    noConversations: 'Nenhuma conversa encontrada',
    selectConversation: 'Selecione uma conversa',
    selectConversationHint: 'Escolha uma conversa da lista para começar',
    selectToViewContext: 'Selecione uma conversa para ver o contexto',
    back: 'Voltar',
    lastActivity: 'Última atividade',
    messagePlaceholder: 'Digite sua mensagem...',
    messageSent: 'Mensagem enviada com sucesso',
    attachment: 'Anexar arquivo',
    emoji: 'Adicionar emoji',
    quickTemplate: 'Modelo rápido',
    noteAdded: 'Nota adicionada com sucesso',
    tagAdded: 'Tag adicionada com sucesso',

    filters: {
      all: 'Todas',
      unread: 'Não Lidas',
      mine: 'Minhas',
      hot: 'Quentes',
      today: 'Hoje',
      tags: 'Tags',
    },

    metrics: {
      title: 'Métricas',
      subtitle: 'Últimos 30 dias',
      expand: 'Expandir métricas',
      collapse: 'Recolher métricas',
      avgResponseTime: 'Tempo médio de resposta',
      responseRate: 'Taxa de resposta',
      conversionRate: 'Taxa de conversão',
      noData: '—',
      lessThanMinute: '< 1 min',
      minutes: '{{count}} min',
      hours: '{{count}} h',
      hoursMinutes: '{{hours}} h {{minutes}} min',
    },

    actions: {
      newConversation: 'Nova conversa',
    },

    quickActions: {
      title: 'Ações rápidas',
      createProposal: 'Criar proposta',
      scheduleTestDrive: 'Agendar test drive',
      linkVehicle: 'Vincular veículo',
      editLead: 'Editar lead',
      addSelectedVehicleInterest: 'Adicionar veículo selecionado nos interesses',
    },

    success: {
      newConversationCreated: 'Conversa pronta. Você pode responder abaixo.',
    },

    leadData: {
      title: 'Dados do Lead',
      name: 'Nome',
      phone: 'Telefone',
      email: 'E-mail',
      source: 'Origem',
      notes: 'Notas',
      condition: 'Condição',
      fuelType: 'Combustível',
      transmission: 'Transmissão',
      minPrice: 'Preço mín.',
      maxPrice: 'Preço máx.',
      minYear: 'Ano mín.',
      maxYear: 'Ano máx.',
      editLead: 'Editar lead',
      cancelEdit: 'Cancelar edição',
      save: 'Salvar dados do lead',
      saving: 'Salvando...',
      updated: 'Dados do lead atualizados',
      updateError: 'Erro ao atualizar dados do lead',
      historyTitle: 'Histórico',
      historyEmpty: 'Nenhuma atividade registrada',
    },

    leadScore: {
      title: 'Lead Score',
      classification: 'Classificação',
      hot: 'Quente',
      warm: 'Morno',
      cold: 'Frio',
    },

    vehicleInterest: {
      title: 'Interesse',
      price: 'Preço',
      viewStock: 'Ver Estoque',
    },

    activity: {
      title: 'Atividade',
      noActivity: 'Nenhuma atividade registrada',
    },

    notes: {
      title: 'Notas',
      placeholder: 'Digite sua nota...',
      add: 'Adicionar',
      cancel: 'Cancelar',
      noNotes: 'Nenhuma nota adicionada',
    },

    tags: {
      title: 'Tags',
      noTags: 'Nenhuma tag adicionada',
    },

    // WhatsApp Templates
    templates: {
      selectTemplate: 'Selecionar Template',
      searchPlaceholder: 'Buscar template...',
      availableTemplates: 'Templates Disponíveis',
      noTemplates: 'Nenhum template disponível',
      category: 'Categoria',
      language: 'Idioma',
      parameters: 'Parâmetros',
      preview: 'Pré-visualização',
      useTemplate: 'Usar Template',
      createNewTemplate: 'Criar Novo Template na Meta',
      templateSent: 'Template enviado com sucesso',

      categories: {
        UTILITY: 'Utilitário',
        MARKETING: 'Marketing',
        AUTHENTICATION: 'Autenticação',
      },

      status: {
        APPROVED: 'Aprovado',
        PENDING: 'Pendente',
        REJECTED: 'Rejeitado',
      },

      errors: {
        notFound: 'Template não encontrado',
        notFoundHint: 'Sincronize os templates nas configurações',
        invalidParameters: 'Parâmetro inválido',
        invalidParametersHint: 'Verifique se preencheu todos os campos obrigatórios',
        sendError: 'Erro ao enviar template',
        loadError: 'Erro ao carregar templates',
        syncError: 'Erro ao sincronizar templates',
      },
    },

    // 24h Window Status
    window24h: {
      active: 'Janela de 24h ativa',
      expired: 'Janela de 24h expirada',
      expiresIn: 'Janela de 24h expira em',
      hours: 'h',
      minutes: 'm',
      needsTemplate: 'Envie um Template para reabrir',
      newConversation: 'Esta é uma nova conversa',
      mustSendTemplate: 'Você deve enviar um Template primeiro',
      selectTemplateButton: 'Selecionar Template',
    },

    // New Conversation Dialog
    newConversation: {
      title: 'Nova Conversa',
      searchLead: 'Buscar lead',
      searchPlaceholder: 'Digite o nome do lead...',
      createNewLead: 'Criar Novo Lead',
      noLeadsFound: 'Nenhum lead encontrado',
      selectLeadFirst: 'Selecione um lead primeiro',
      leadNoPhone: 'Este lead não possui telefone cadastrado',
      conversationStarted: 'Conversa iniciada! Envie a primeira mensagem usando um template.',
      templateNote: 'A primeira mensagem deve ser um template aprovado pela Meta. Após abrir a conversa, clique em "Selecionar Template" para enviar.',
      nameRequired: 'Nome é obrigatório',
      phoneRequired: 'Telefone é obrigatório',
      leadCreated: 'Lead criado com sucesso',
      createLeadError: 'Erro ao criar lead',
      startError: 'Erro ao iniciar conversa',
      startConversation: 'Iniciar Conversa',
      initialMessage: 'Mensagem inicial (opcional)',
      initialMessagePlaceholder: 'Digite uma mensagem inicial...',
      selectTemplate: 'Selecionar Template',
      selectTemplatePlaceholder: 'Escolha um template...',
      selectTemplateFirst: 'Selecione um template primeiro',
      fillAllParameters: 'Preencha todos os parâmetros',
      parameter: 'Parâmetro',
      parameters: 'Parâmetros',
      preview: 'Pré-visualização',
      templateSent: 'Template enviado com sucesso',
      sendAndStart: 'Enviar e Iniciar',
      orCreateNew: 'Ou crie um novo lead',
      name: 'Nome',
      namePlaceholder: 'Digite o nome',
      phone: 'Telefone',
      phonePlaceholder: 'Digite o telefone',
      email: 'E-mail',
      emailPlaceholder: 'Digite o e-mail',
      source: 'Origem',
      createLead: 'Criar Lead',
      new: 'Nova Conversa',
    },

    // Quick Templates
    quickTemplates: {
      title: 'Templates Rápidos',
      greeting: 'Saudação',
      proposal: 'Proposta',
      scheduling: 'Agendamento',
    },

    errors: {
      sendError: 'Erro ao enviar mensagem',
      loadLeadError: 'Erro ao carregar dados do lead',
      loadTemplatesError: 'Erro ao carregar templates',
      notConfigured: 'WhatsApp não configurado',
      notConfiguredDesc: 'Configure o WhatsApp antes de usar as conversas',
      configure: 'Configurar WhatsApp',
      loadError: 'Erro ao carregar conversas',
    },
  },

  billing: {
    title: 'Assinatura e cobrança',
    subtitle: 'Gerencie seu plano, pagamentos e histórico de faturas da concessionária',
    settingsCardTitle: 'Assinatura e cobrança',
    settingsCardDescription: 'Plano atual, upgrade, método de pagamento e faturas',
    currentPlan: 'Plano atual',
    currentPlanBadge: 'Plano atual',
    plansTitle: 'Planos disponíveis',
    plansSubtitle: 'Compare e faça upgrade do seu plano',
    invoicesTitle: 'Histórico de pagamentos',
    invoicesSubtitle: 'Faturas geradas pela assinatura',
    noInvoices: 'Nenhuma fatura registrada ainda.',
    invoiceDate: 'Data',
    invoiceAmount: 'Valor',
    invoiceStatus: 'Status',
    invoicePaidAt: 'Pago em',
    viewInvoice: 'Ver fatura',
    nextPayment: 'Próximo pagamento',
    lastPayment: 'Último pagamento',
    trialEnd: 'Fim do trial',
    monthly: 'Mensal',
    yearly: 'Anual',
    month: 'mês',
    year: 'ano',
    managePayment: 'Configurar pagamento',
    completePayment: 'Concluir pagamento',
    upgradePlan: 'Fazer upgrade',
    cancelSubscription: 'Cancelar assinatura',
    cancelConfirm: 'Deseja cancelar a assinatura ao final do período atual?',
    cancelScheduled: 'Cancelamento agendado para o fim do período.',
    cancelAtPeriodEnd: 'Cancela ao fim do período',
    checkoutSuccess: 'Pagamento configurado com sucesso.',
    checkoutCancelled: 'Checkout cancelado. Nenhuma alteração foi feita.',
    planChanged: 'Plano atualizado com sucesso.',
    noSubscriptionTitle: 'Assinatura não encontrada',
    noSubscriptionDescription: 'Entre em contato com o suporte ou escolha um plano abaixo para ativar a cobrança.',
    status: {
      incomplete: 'Pagamento pendente',
      trialing: 'Período de teste',
      active: 'Ativa',
      past_due: 'Pagamento em atraso',
      canceled: 'Cancelada',
      unpaid: 'Não paga',
    },
    errors: {
      load: 'Erro ao carregar assinatura',
      portal: 'Não foi possível abrir o portal de pagamento',
      ownerOnlyPortal: 'Somente o owner pode alterar método de pagamento no portal.',
      changePlan: 'Erro ao alterar plano',
      downgrade: 'Não é possível fazer downgrade: limites do plano excedidos',
      cancel: 'Erro ao cancelar assinatura',
      noSubscription: 'Assinatura não configurada',
      samePlan: 'Este já é o seu plano atual',
    },
  },

  ui: {
    languageSwitcher: {
      triggerLabel: 'Selecionar idioma',
      triggerTitle: 'Abrir seletor de idioma',
      languages: {
        pt: 'Português',
        en: 'Inglês',
        es: 'Espanhol',
      },
    },
  },

  notFound: {
    title: 'Página não encontrada',
    message: 'A página que você está procurando não existe ou foi movida.',
    backToDashboard: 'Voltar ao painel',
    backToPlans: 'Ver planos',
  },

  publicPlans: {
      hero: {
        eyebrow: 'Planos',
        title: 'Escolha o plano ideal para sua concessionária',
        subtitle:
          'Compare limites e recursos, escolha a cobrança mensal ou anual e siga para o cadastro.',
        trust1: 'Sem fidelidade',
        trust2: 'Ativação imediata',
        trust3: 'Suporte incluso',
        alreadyHaveAccount: 'Já tem uma conta?',
        loginLink: 'Fazer login',
      },
      summary: {
        title: 'Resumo da seleção',
        subtitle: 'Confira o plano antes de avançar.',
        priceLabelMonthly: '/mês',
        priceLabelYearly: '/ano',
        selectedPlan: 'Plano escolhido',
        hint: 'Selecione um plano para continuar',
      },
      actions: {
        continue: 'Continuar',
        selectPlan: 'Selecionar plano',
        selected: 'Selecionado',
      },
      comparison: {
        title: 'Comparativo de recursos',
        resources: 'Recursos',
      },
      badges: {
        mostPopular: 'Mais popular',
        saveUpTo: 'Economize até {{discount}}%',
      },
      features: {
        vehicles: 'Veículos',
        users: 'Usuários',
        leads: 'Leads',
        support: 'Suporte',
        analytics: 'Analytics',
        customization: 'Personalização',
        apiAccess: 'Acesso à API',
        multipleLocations: 'Múltiplas localizações',
        unlimited: 'Ilimitado',
        supportLevels: {
          none: 'Nenhum',
          email: 'E-mail',
          priority: 'Prioritário',
          dedicated: 'Dedicado',
        },
        analyticsLevels: {
          none: 'Nenhum',
          basic: 'Básico',
          advanced: 'Avançado',
          custom: 'Personalizado',
        },
      },
      billing: {
        monthly: 'Mensal',
        yearly: 'Anual',
      },
      errors: {
        title: 'Erro ao carregar planos',
        retry: 'Tentar novamente',
        loading: 'Carregando planos…',
      },
    },

  publicOnboarding: {
      stepTitles: {
        config: 'Configurações e acesso',
        summary: 'Resumo final',
      },
      stepDescriptions: {
        config: 'Crie o acesso administrativo e ajuste o básico fiscal.',
        summary: 'Revise as informações antes de concluir.',
      },
    },

  auth: {
    login: {
      title: 'Entre na sua conta',
      subtitle: 'ambcar · Gestão de Concessionárias',
      email: 'E-mail',
      emailPlaceholder: 'seu@email.com',
      password: 'Senha',
      passwordPlaceholder: '••••••••',
      rememberMe: 'Lembrar de mim',
      forgotPassword: 'Esqueceu sua senha?',
      submit: 'Entrar',
      submitting: 'Entrando...',
      noAccount: 'Não tem uma conta?',
      registerLink: 'Cadastre sua empresa',
      needHelp: 'Precisa de ajuda?',
      contactUs: 'Entre em contato conosco',
      brand: {
        headline: 'A plataforma completa para gestão de concessionárias',
        text1: 'Gerencie seu estoque com inteligência e velocidade',
        text2: 'Leads qualificados, fechamentos mais rápidos',
        text3: 'Visibilidade total do seu pipeline de vendas',
        text4: 'Automatize processos, foque em resultados',
        text5: 'Decisões comerciais mais rápidas, operação mais eficiente',
        feature1: 'Gestão completa de estoque automotivo',
        feature2: 'Pipeline de vendas em tempo real',
        feature3: 'Integração WhatsApp e CRM nativo',
      },
      errors: {
        invalidCredentials: 'Email ou senha incorretos',
        invalidCredentialsMsg: 'As credenciais fornecidas não conferem com nossos registros.',
        invalidCredentialsSuggestion: 'Verifique se digitou corretamente seu email e senha. Lembre-se que a senha diferencia maiúsculas de minúsculas.',
        accessBlocked: 'Acesso bloqueado',
        accessBlockedMsg: 'Sua conta está bloqueada ou você não tem permissão para acessar este sistema.',
        accessBlockedSuggestion: 'Entre em contato com o administrador da sua concessionária ou com nosso suporte para mais informações.',
        connectionError: 'Erro de conexão',
        connectionErrorMsg: 'Não foi possível estabelecer conexão com o servidor.',
        connectionErrorSuggestion: 'Verifique sua conexão com a internet e tente novamente. Se o problema persistir, nossos servidores podem estar em manutenção.',
        timeout: 'Tempo limite excedido',
        timeoutMsg: 'A solicitação demorou muito tempo para ser processada.',
        timeoutSuggestion: 'Isso pode indicar instabilidade na conexão. Aguarde alguns segundos e tente novamente.',
        serverError: 'Servidor temporariamente indisponível',
        serverErrorMsg: 'Nossos servidores estão enfrentando problemas técnicos no momento.',
        serverErrorSuggestion: 'Nossa equipe já foi notificada. Por favor, tente novamente em alguns minutos.',
        tooManyAttempts: 'Muitas tentativas de login',
        tooManyAttemptsMsg: 'Você excedeu o número máximo de tentativas de login.',
        tooManyAttemptsSuggestion: 'Por segurança, aguarde 15 minutos antes de tentar novamente.',
        generic: 'Erro ao fazer login',
        genericMsg: 'Ocorreu um erro inesperado ao tentar fazer login.',
        genericSuggestion: 'Verifique suas credenciais e tente novamente. Se o problema persistir, entre em contato com o suporte.',
      },
      forgotPasswordInfo: 'Recuperação de senha',
      forgotPasswordInfoMsg: 'Funcionalidade em desenvolvimento.',
      forgotPasswordInfoSuggestion: 'Entre em contato com o administrador da sua concessionária ou com nosso suporte para redefinir sua senha.',
    },
    verifyEmail: {
      loginRequiredMessage: 'Seu e-mail precisa ser verificado antes de entrar. Verifique sua caixa de entrada para encontrar o código.',
      title: 'Verifique seu e-mail',
      subtitle: 'Enviamos um código de 6 dígitos para',
      instruction: 'Digite o código de verificação',
      placeholder: '0',
      submit: 'Verificar',
      submitting: 'Verificando...',
      resend: 'Reenviar código',
      resending: 'Reenviando...',
      resendIn: 'Reenviar em {{seconds}}s',
      expiresIn: 'O código expira em',
      expired: 'O código expirou',
      minutes: '{{minutes}} min',
      seconds: '{{seconds}}s',
      backToLogin: 'Voltar para o login',
      didNotReceive: 'Não recebeu o código?',
      checkSpam: 'Verifique também sua caixa de spam',
      brand: {
        headline: 'Quase lá!',
        text1: 'Estamos verificando sua identidade para proteger sua conta',
        text2: 'A verificação de e-mail garante a segurança dos seus dados',
        text3: 'Em instantes você terá acesso completo à plataforma',
        feature1: 'Proteção avançada da sua conta',
        feature2: 'Acesso seguro aos dados da concessionária',
        feature3: 'Conformidade com boas práticas de segurança',
      },
      success: {
        title: 'E-mail verificado!',
        message: 'Seu e-mail foi verificado com sucesso. Você já pode acessar sua conta.',
      },
      errors: {
        invalidCode: 'Código inválido',
        invalidCodeMsg: 'O código de verificação informado não é válido.',
        invalidCodeSuggestion: 'Verifique se digitou corretamente todos os 6 dígitos do código recebido por e-mail.',
        expiredCode: 'Código expirado',
        expiredCodeMsg: 'O código de verificação expirou.',
        expiredCodeSuggestion: 'Clique em "Reenviar código" para receber um novo código de verificação.',
        notFound: 'Código não encontrado',
        notFoundMsg: 'Nenhum código de verificação foi encontrado para este e-mail.',
        notFoundSuggestion: 'Clique em "Reenviar código" para solicitar um novo código.',
        alreadyVerified: 'E-mail já verificado',
        alreadyVerifiedMsg: 'Este e-mail já foi verificado anteriormente.',
        generic: 'Erro na verificação',
        genericMsg: 'Ocorreu um erro ao verificar o código.',
        genericSuggestion: 'Tente novamente. Se o problema persistir, solicite um novo código.',
        resendFailed: 'Erro ao reenviar',
        resendFailedMsg: 'Não foi possível reenviar o código de verificação.',
        resendFailedSuggestion: 'Verifique sua conexão e tente novamente em alguns instantes.',
      },
    },
  },
}

export type TranslationKeys = typeof pt
